
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4Svbr", function(module, exports) {
/* CommentReplies.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $7EEGh = parcelRequire("7EEGh");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $ccHMk = parcelRequire("ccHMk");


var $3ejfs = parcelRequire("3ejfs");


var $fHAwL = parcelRequire("fHAwL");


var $hXzKU = parcelRequire("hXzKU");


var $666Tc = parcelRequire("666Tc");


var $8i27m = parcelRequire("8i27m");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $NYiei = parcelRequire("NYiei");


var $ag51I = parcelRequire("ag51I");


var $cQCqE = parcelRequire("cQCqE");


var $cD1qu = parcelRequire("cD1qu");


var $ep3mz = parcelRequire("ep3mz");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $1Sjzs = parcelRequire("1Sjzs");


var $bQm3c = parcelRequire("bQm3c");


var $hl1Kw = parcelRequire("hl1Kw");


var $58Zuw = parcelRequire("58Zuw");


var $lLpk8 = parcelRequire("lLpk8");


var $ibqdE = parcelRequire("ibqdE");


var $8gR6k = parcelRequire("8gR6k");

/* GeneralReplyScroller.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $2Pg7f = parcelRequire("2Pg7f");








var $fURMF = parcelRequire("fURMF");

const $2e558da207609fcd$var$replyScrollerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    marginTop: "var(--ds-space-150, 12px)",
    left: 0
};
const $2e558da207609fcd$var$replyScrollerBranchingStyle = null;
const $2e558da207609fcd$var$replyWrapperWithSpacingStyles = {
    paddingTop: "var(--ds-space-100, 8px)"
};
const $2e558da207609fcd$var$leftMargin = null;
const $2e558da207609fcd$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
}); // This snippet is being used in CommentBody.tsx
const $2e558da207609fcd$var$dotStyles = null;
const $2e558da207609fcd$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'radius.small',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $2e558da207609fcd$var$i18n = (0, $cgtv4.defineMessages)({
    commentsPanelShowGeneralNestedReplies: {
        id: "comments-common.comment-thread.go.to.nested.general.reply",
        defaultMessage: "Go to more replies"
    },
    commentsPanelGeneralNestedRepliesHasUnread: {
        id: "comments-common.comment-thread.general.nested.replies.has.unread",
        defaultMessage: "There are unread replies"
    }
});
const $2e558da207609fcd$export$a0769df2292690a8 = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const maxProfilePicturesToShow = 3; // If any of the nestedReplies match an ID in unreadReplyIds, render the blue dot indicator
    const unreadReplyIdsSet = new Set(unreadReplyIds);
    const shouldRenderBlueDotIndicator = nestedReplies.some((reply)=>unreadReplyIdsSet.has(reply.id));
    const avatarsToShow = (0, $42omo.useMemo)(()=>{
        const uniqueAccountsMap = new Map(); // Start from the end of the list and move backwards
        for(let i = nestedReplies.length - 1; i >= 0; i--){
            const reply = nestedReplies[i];
            const { displayName: displayName, profilePicture: profilePicture } = reply.author; // Determine if the author has an accountId, anonymous users don't have accountId
            let uniqueKey;
            if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
            else // Fallback for anonymous users or if accountId is not present
            uniqueKey = `anonymous-${i}`;
            if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
                displayName: displayName ?? '',
                profilePicturePath: profilePicture?.path
            });
        }
        const avatars = Array.from(uniqueAccountsMap.values());
        const mappedAvatars = avatars.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            }));
        return mappedAvatars;
    }, [
        nestedReplies
    ]);
    // NOTE: This component replicates a lot of the code in RepliesToggler.tsx
    // However, GeneralReplyScroller is only used for multi nested general comment replies for pages created before the single threading general comments feature was introduced
    // All new pages created after this time will use RepliesScroller instead of GeneralReplyScroller
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _18u01jfw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "comments-panel-reply-scroller-container",
        showDefaultStyles: true,
        customStyles: {
            ...$2e558da207609fcd$var$replyScrollerStyles,
            ...$2e558da207609fcd$var$replyWrapperWithSpacingStyles
        },
        disableLeftProp: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u0utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: ()=>{
            const targetElementId = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? `footer-comment-thread-${targetCommentIdForScroll}-replies` : `comment-${targetCommentIdForScroll}-footer`;
            const commentElement = document.getElementById(targetElementId); // NOTE - redesigned footer comments don't yet all load when the panel is opened, so may not be in the DOM
            // In cases where this is not yet in the DOM, we treat it like clicking the comment body in commentThreadHelper#shouldTriggerCommentScroll
            if (commentElement) {
                const offset = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? -60 : -75; // Redesigned footer comments have a slightly different height
                (0, $fURMF.scrollToElement)(commentElement, offset, 'smooth');
            }
        },
        testId: "comments-panel-thread-show-nested-general-replies",
        xcss: $2e558da207609fcd$var$pressableStyles,
        interactionName: "comments-panel-thread-show-nested-general-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, avatarsToShow.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: avatarsToShow,
        maxCount: maxProfilePicturesToShow,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "comments-panel-replies-scroller-profile-pictures"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $2e558da207609fcd$var$unreadIndicatorStyle
    }, formatMessage($2e558da207609fcd$var$i18n.commentsPanelShowGeneralNestedReplies), shouldRenderBlueDotIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "comments-panel-unread-nested-general-replies-indicator",
        "aria-label": formatMessage($2e558da207609fcd$var$i18n.commentsPanelGeneralNestedRepliesHasUnread),
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _18s81b66 _4t3iu2gc _1bsbu2gc _bfhk1856"
        ])
    }))))))));
};



var $i6UMJ = parcelRequire("i6UMJ");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $en1dX = parcelRequire("en1dX");


var $cZa7r = parcelRequire("cZa7r");


var $6hmtW = parcelRequire("6hmtW");


var $7qvmT = parcelRequire("7qvmT");







const $9425ea2b46ac8b73$export$a213d462a9569b77 = ({ isCurrentSelectedComment: isCurrentSelectedComment, visibleUnreadRepliesNotMarkedAsRead: visibleUnreadRepliesNotMarkedAsRead, threadKey: threadKey, commentType: commentType, setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead, updateUnreadCommentsListState: updateUnreadCommentsListState })=>{
    // if selecting the comment thread, we need to mark all visible replies as read as well
    // we'll let setCommentsInThreadToBeMarkedAsRead handle duplicates if any
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (isCurrentSelectedComment && visibleUnreadRepliesNotMarkedAsRead.length > 0) {
            setCommentsInThreadToBeMarkedAsRead({
                threadKey: threadKey,
                commentIds: visibleUnreadRepliesNotMarkedAsRead,
                commentType: commentType
            });
            updateUnreadCommentsListState((prev)=>{
                const repliesIds = new Set(visibleUnreadRepliesNotMarkedAsRead);
                return prev.filter((unreadComment)=>{
                    if (repliesIds.has(unreadComment.id)) return false;
                    return true;
                });
            });
        }
    }, [
        commentType,
        isCurrentSelectedComment,
        setCommentsInThreadToBeMarkedAsRead,
        threadKey,
        updateUnreadCommentsListState,
        visibleUnreadRepliesNotMarkedAsRead
    ]);
};



var $9tfnI = parcelRequire("9tfnI");

const $ff4f83a3b963012b$var$CommentRepliesCreateInlineReplyMutation = (0, $eSUdr.default)`mutation CommentRepliesCreateInlineReplyMutation($input:ReplyInlineCommentInput!$pageId:ID!$includeReactions:Boolean!){replyInlineComment(input:$input){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactions){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}`;
const $ff4f83a3b963012b$var$CommentRepliesCreateGeneralReplyMutation = (0, $eSUdr.default)`mutation CommentRepliesCreateGeneralReplyMutation($pageId:ID!$cloudId:ID!$input:CreateCommentInput!$includeReactions:Boolean!){createFooterComment(cloudId:$cloudId input:$input){id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactions){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}version{by{displayName}when number}}}`;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStyles = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStandaloneStyleOverrides = null;
const $ff4f83a3b963012b$var$commentHandlesPaddingReplyBoxOverrides = null;
const $ff4f83a3b963012b$var$replyBoxStyles = null;
const $ff4f83a3b963012b$var$oldReplyBoxStyles = null;
const $ff4f83a3b963012b$var$translucentStyle = null;
const $ff4f83a3b963012b$var$replyListStaticStraightBorders = null;
const $ff4f83a3b963012b$var$replyActionButtonStyles = {
    marginLeft: "var(--ds-space-150, 12px)",
    width: '62px',
    height: '24px',
    left: '-12px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$customizedReplyButtonStyles = null; // This would cause the branching style to jump when clicking reply
const $ff4f83a3b963012b$var$commentEditorLegacyCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    height: '16px',
    marginRight: "var(--ds-space-050, 4px)"
};
const $ff4f83a3b963012b$var$commentEditorCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    height: '24px',
    // 24px = 16px offset + 8px of padding
    marginRight: "var(--ds-space-050, 4px)",
    paddingTop: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$i18n = (0, $cgtv4.defineMessages)({
    replyAction: {
        id: "comments-panel.reply.action",
        defaultMessage: "Reply"
    },
    threadReplyButtonAriaLabelWithName: {
        id: "comments-panel.reply.button.aria-label.with-name",
        defaultMessage: "Reply to {name}\u2019s thread"
    },
    replyAriaLabel: {
        id: "comments-panel.reply.aria-label",
        defaultMessage: "Reply by {authorName}, {timestamp}"
    }
});
const $ff4f83a3b963012b$export$c38311e545a763a = ({ parentComment: parentComment, pageInfo: pageInfo, isCurrentSelectedComment: isCurrentSelectedComment, hoveredCommentId: hoveredCommentId, pageMode: pageMode, editCommentQueryId: editCommentQueryId, selectedAnnotation: selectedAnnotation, parentCommentId: parentCommentId, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, isStandaloneComment: isStandaloneComment, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn, onRendered: onRendered, eventEmitter: eventEmitter, isEditorExpanded: isEditorExpanded = false, hasParentMaxHeight: hasParentMaxHeight = false })=>{
    const [createInlineReplyFn] = (0, $diswb.useMutation)($ff4f83a3b963012b$var$CommentRepliesCreateInlineReplyMutation);
    const [createGeneralReplyFn] = (0, $diswb.useMutation)($ff4f83a3b963012b$var$CommentRepliesCreateGeneralReplyMutation);
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const { createInlineReplyInterop: createInlineReplyInterop } = (0, $cQCqE.useCreateInlineReplyMutation)({
        contentId: pageId
    });
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addReplyToCommentThread: addReplyToCommentThread } = (0, $8i27m.useCommentsDataActions)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const [{ commentsMarkedAsRead: commentsMarkedAsRead, replyToCommentId: replyToCommentId, location: location, replyToCommentUser: replyToCommentUser }, { setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead, setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const [{ unreadCommentIDSet: unreadCommentIDSet }, { updateUnreadCommentsListState: updateUnreadCommentsListState, updateReadCommentsListState: updateReadCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const allReplies = (0, $42omo.useMemo)(()=>{
        if ((0, $6mKj3.expValEquals)('confluence_frontend_replytoggler_fix', 'isEnabled', true)) return parentComment.replies.filter((r)=>r !== null && parentComment.location.inlineMarkerRef === r.location.inlineMarkerRef);
        return parentComment.replies.filter((r)=>r !== null);
    }, [
        parentComment.replies,
        parentComment.location
    ]);
    const numOfReplies = allReplies.length;
    const unreadReplyIds = (0, $42omo.useMemo)(()=>{
        return allReplies.filter((r)=>(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? unreadCommentIDSet.has(r.id) : r.isUnread).map((r)=>r.id);
    }, [
        allReplies,
        unreadCommentIDSet
    ]); // Show the latest replies in the thread by default
    const [shouldShowLatestReplies, setShouldShowLatestReplies] = (0, $42omo.useState)(true);
    const [visibleReplies, setVisibleReplies] = (0, $42omo.useState)(undefined);
    const [, setCommentForEdit] = (0, $42omo.useState)('');
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(null);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const commentType = parentComment.type;
    const inlineCommentLocation = parentComment?.location;
    const isDanglingComment = inlineCommentLocation?.inlineResolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
    const isParentCommentOpen = parentComment.isOpen;
    const isParentCommentResolvedOrDangling = !isParentCommentOpen || Boolean(isDanglingComment);
    const [currentReplyView, setReplyView] = (0, $42omo.useState)(// Determine the reply view by counting the total number of top-level replies to the parent comment.
    // This excludes any nested replies.
    (0, $7qvmT.getDefaultReplyView)((0, $ibqdE.getCommentReplies)(allReplies, parentCommentId).length, isParentCommentResolvedOrDangling, isStandaloneComment)); // User page permissions
    const operations = pageInfo?.operations || [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    const threadKey = commentType === (0, $8i27m.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || '' : parentCommentId;
    const supportedTopLevelActions = isParentCommentOpen ? [
        'edit',
        'resolve',
        'delete'
    ] : [
        'reopen'
    ]; // reopen won't be rendered for reply, but we are using it to render disabled reaction summary for replies
    const expandReplyEditor = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? isEditorExpanded : location === (0, $i6UMJ.LocationValue).PANEL && (replyToCommentId === parentCommentId || allReplies.some((reply)=>reply.id === replyToCommentId) && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true));
    const visibleUnreadRepliesNotMarkedAsRead = (0, $42omo.useMemo)(()=>{
        // the new unread architecture in next/packages/unread-comments/src/hooks/useUnreadComments.ts does not use this hook, so feature gating this out
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return [];
        return (visibleReplies ?? []).filter((reply)=>{
            const markedReplies = commentsMarkedAsRead[commentType][threadKey]; // Check if the reply id is not in the markedReplies set
            return (!markedReplies || !markedReplies.has(reply.id)) && reply.isUnread;
        }).map((reply)=>reply.id);
    }, [
        visibleReplies,
        commentsMarkedAsRead,
        threadKey,
        commentType
    ]);
    const numOfHiddenReplies = (0, $42omo.useRef)(currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL ? 0 : numOfReplies - (visibleReplies?.length ?? 0)); // Track if we've already fired the analytics event for current visibleReplies state
    const hasFiredForVisibleRepliesRef = (0, $42omo.useRef)('');
    const topLevelReplyToNestedChildrenMap = (0, $42omo.useMemo)(()=>{
        const topLevelReplyIds = new Set(allReplies.filter((reply)=>reply.parentId === parentCommentId).map((reply)=>reply.id)); // We need to get all replies that are nested to any depth under a top level reply.
        // This will help us render the GeneralReplyScroller component for each reply (mainly, we need to show user icons and the blue dot indicator)
        const topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce((acc, replyId)=>{
            acc[replyId] = [];
            return acc;
        }, {});
        const replyIdToReplyMap = allReplies.reduce((acc, reply)=>{
            acc[reply.id] = reply;
            return acc;
        }, {}); // Map all replies to their top level parent. Replies can be nested to any depth, so we need to traverse the tree.
        const filteredReplies = allReplies.filter((reply)=>!topLevelReplyIds.has(reply.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId; // Add a circuit breaker to prevent infinite loops if we get really wonky data
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) // Second condition will always be true, unless we somehow hit circuit breaker above
            topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        return topLevelReplyToNestedChildrenMapInternal;
    }, [
        allReplies,
        parentCommentId
    ]); // Determine the latest top level replies to show on the thread's initial load
    const latestReplies = (0, $42omo.useMemo)(()=>{
        const replies = [];
        const topLevelReplies = allReplies.filter((reply)=>reply.id in topLevelReplyToNestedChildrenMap); // Sort by createdAtNonLocalized value
        topLevelReplies.sort((a, b)=>{
            // Safely handle missing or invalid dates
            const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
            const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
            return dateA.getTime() - dateB.getTime();
        }); // Add the latest replies to the replies array
        for(let i = 0; i < (0, $7qvmT.getDefaultNumVisibleReplies)(numOfReplies, isStandaloneComment, isParentCommentResolvedOrDangling); i++)if (topLevelReplies.length > 0) {
            const reply = topLevelReplies.pop();
            if (reply) // Unshift to maintain reply chronological order
            replies.unshift(reply);
        }
        return replies;
    }, [
        allReplies,
        isStandaloneComment,
        numOfReplies,
        topLevelReplyToNestedChildrenMap,
        isParentCommentResolvedOrDangling
    ]); /*
                                                                                                                             * Determine the latest top level reply IDs and their nested reply IDs.
                                                                                                                             * This is passed to RepliesToggler to determine the hidden replies.
                                                                                                                             */ 
    const latestReplyIds = (0, $42omo.useMemo)(()=>{
        const latestAndNestedReplyIds = new Set();
        for (const reply of latestReplies){
            latestAndNestedReplyIds.add(reply.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        return latestAndNestedReplyIds;
    }, [
        latestReplies,
        topLevelReplyToNestedChildrenMap
    ]);
    (0, $9425ea2b46ac8b73$export$a213d462a9569b77)({
        isCurrentSelectedComment: isCurrentSelectedComment,
        visibleUnreadRepliesNotMarkedAsRead: visibleUnreadRepliesNotMarkedAsRead,
        threadKey: threadKey,
        commentType: commentType,
        setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead,
        updateUnreadCommentsListState: updateUnreadCommentsListState
    }); // Wrapper for setVisibleReplies to match the expected type signature
    const setVisibleRepliesWrapper = (0, $42omo.useCallback)((value)=>{
        if (typeof value === 'function') setVisibleReplies((prev)=>{
            const prevArray = prev === undefined ? [] : prev;
            return value(prevArray);
        });
        else setVisibleReplies(value);
    }, []);
    (0, $8gR6k.useUpdateVisibleReplies)({
        allReplies: allReplies,
        commentType: commentType,
        isParentCommentOpen: isParentCommentOpen,
        currentReplyView: currentReplyView,
        latestReplies: latestReplies,
        latestReplyIds: latestReplyIds,
        parentCommentId: parentCommentId,
        setVisibleReplies: setVisibleRepliesWrapper,
        shouldShowLatestReplies: shouldShowLatestReplies,
        numOfHiddenReplies: numOfHiddenReplies
    }); // Track replies rendered state in experience tracker
    // Extract visibleReplies length to avoid complex expression in dependency array
    const visibleRepliesLength = visibleReplies?.length ?? -1;
    (0, $42omo.useEffect)(()=>{
        if (visibleReplies === undefined) return;
        const repliesRendered = currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL && visibleReplies.length > 0; // Fire GASV3 event only when in ALL view with replies and we haven't fired for this state yet
        if (currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL && visibleReplies.length > 0) {
            const stateKey = `${currentReplyView}-${visibleReplies.length}`; // Only fire if we haven't already fired for this exact state
            if (hasFiredForVisibleRepliesRef.current !== stateKey && numOfReplies !== 0) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'repliesRenderedStateChanged',
                        actionSubject: 'comment',
                        actionSubjectId: parentCommentId,
                        objectType: pageType,
                        objectId: pageId,
                        source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        attributes: {
                            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
                            repliesRendered: repliesRendered,
                            currentReplyView: currentReplyView,
                            numOfReplies: numOfReplies,
                            visibleRepliesCount: visibleReplies.length
                        }
                    }
                }).fire(); // Mark this state as fired
                hasFiredForVisibleRepliesRef.current = stateKey;
            }
        }
    }, [
        currentReplyView,
        visibleReplies,
        visibleRepliesLength,
        numOfReplies,
        commentType,
        experienceTracker,
        createAnalyticsEvent,
        parentCommentId,
        pageType,
        pageId,
        isStandaloneComment
    ]);
    const removeAnnotationHighlight = (0, $42omo.useCallback)(()=>{
        if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
        else eventEmitter?.emit('setselectedannotation', null);
    }, [
        pageMode,
        eventEmitter
    ]); // Reset ref on component unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            hasFiredForVisibleRepliesRef.current = ''; //TODO: Remove once https://product-fabric.atlassian.net/browse/COMMENTS-5857 is resolved
            const isDatabaseOrWhiteboard = contentType === 'database' || contentType === 'whiteboard';
            if (!isDatabaseOrWhiteboard && (0, $6mKj3.expValEquals)('confluence_comment_reset_reply_options', 'isEnabled', true)) {
                setReplyToCommentId();
                removeAnnotationHighlight();
            }
        };
    }, [
        removeAnnotationHighlight,
        setReplyToCommentId,
        contentType
    ]);
    const handleReplyButtonClick = ()=>{
        // Skip if there is no active inline comment annotation and currentlySelectedComment is not general
        const shouldRemoveAnnotationHighlight = commentType === (0, $8i27m.CommentType).GENERAL && selectedAnnotation.id && (0, $9wGTI.fg)('confluence_comment_panel_footer_reply_editor_focus');
        if (hasContentChanged) // if the content has changed and the user has clicked reply button to another comment thread, warn the user
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setReplyToCommentId({
                    parentCommentId: parentCommentId,
                    location: (0, $i6UMJ.LocationValue).PANEL
                });
                shouldRemoveAnnotationHighlight && eventEmitter && removeAnnotationHighlight();
            }
        });
        else {
            setReplyToCommentId({
                parentCommentId: parentCommentId,
                location: (0, $i6UMJ.LocationValue).PANEL
            });
            shouldRemoveAnnotationHighlight && eventEmitter && removeAnnotationHighlight();
        }
    };
    const handleFocus = (0, $42omo.useCallback)((event, replyId)=>{
        event.stopPropagation();
        setCommentIsFocused(replyId);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(null);
    }, [
        setCommentIsFocused
    ]);
    const renderReplyButton = ()=>{
        return isParentCommentOpen && canAddComments && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: $ff4f83a3b963012b$var$replyActionButtonStyles,
            testId: "comments-panel-reply-comment-action",
            onClick: handleReplyButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            "data-cy": "comments-panel-reply-comment-action",
            appearance: "subtle",
            isDisabled: !isParentCommentOpen,
            analyticsContext: {
                attributes: {
                    name: 'replyToCommentButton',
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                }
            },
            interactionName: "start-reply-comment-action" // TODO - COMMENTS-4934: Clean up confluence_frontend_comments_a11y_kb_exp FG
            ,
            ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
                'aria-label': formatMessage($ff4f83a3b963012b$var$i18n.threadReplyButtonAriaLabelWithName, {
                    name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
                })
            } : {},
            className: (0, $gMc0m.default)([
                "_1tv3glyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ff4f83a3b963012b$var$i18n.replyAction)));
    };
    const editorChangeHandler = ()=>{
        let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
        if (commentType === (0, $8i27m.CommentType).GENERAL) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
        experienceTracker.succeed({
            name: experienceName
        });
        if (!(0, $9wGTI.fg)('confluence_comments_unified_navigation')) scrollCommentsPanelToThread({
            annotationId: threadKey,
            scrollToEnd: true
        });
    }; // Wrap the createInlineReplyFn mutation with the interop logic that handles both the direct
    // Apollo mutation path and the new hook-based path for the Comments Data Manager
    const replyCreationInteropWrapper = (0, $42omo.useCallback)((options, onCacheUpdateError)=>createInlineReplyInterop({
            originalMutationFn: createInlineReplyFn,
            options: options,
            onCacheUpdateError: onCacheUpdateError
        }), [
        createInlineReplyInterop,
        createInlineReplyFn
    ]);
    const renderCommentEditor = ()=>{
        let customBranchingStyles = {};
        if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            customBranchingStyles = $ff4f83a3b963012b$var$commentEditorLegacyCustomStyles;
            if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // Accounts for extra padding in the author (was previously handled in a higher parent component)
            customBranchingStyles = $ff4f83a3b963012b$var$commentEditorCustomStyles;
        }
        const editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
            pageId: pageId,
            pageType: pageType,
            content: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser) : undefined,
            appearance: "chromeless",
            EditorComponent: (0, $7EEGh.ChromelessEditor),
            onSaveComment: (adf, onSuccess)=>{
                return (0, $7qvmT.onSaveReply)({
                    pageId: pageId,
                    parentCommentId: parentCommentId,
                    cloudId: cloudId,
                    adf: adf,
                    onSuccess: onSuccess,
                    pageMode: pageMode,
                    editCommentQueryId: editCommentQueryId,
                    setCommentForEdit: setCommentForEdit,
                    createAnalyticsEvent: createAnalyticsEvent,
                    pageType: pageType,
                    experienceTracker: experienceTracker,
                    createInlineReplyFn: replyCreationInteropWrapper,
                    createGeneralReplyFn: createGeneralReplyFn,
                    createObjectReplyFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? createObjectCommentMutationFn : undefined,
                    addCommentInCommentsDataManagerCacheFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? addCommentInCache : undefined,
                    setReplyToCommentId: setReplyToCommentId,
                    resetContentChanged: resetContentChanged,
                    setReplyView: setReplyView,
                    selectedAnnotation: selectedAnnotation,
                    addReplyToCommentThread: addReplyToCommentThread,
                    threadKey: threadKey,
                    updateReadCommentsListState: updateReadCommentsListState,
                    commentType: commentType,
                    searchSessionId: searchSessionId,
                    isReactionsEnabled: isReactionsEnabled,
                    analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    contentTypesCommentService: commentService
                });
            },
            onContentChange: onChange,
            onEditorReady: editorChangeHandler,
            commentMode: "reply",
            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
            spaceId: "",
            showCancelButton: true,
            useNewWarningModal: true,
            hideWatchCheckbox: true,
            expandEditor: expandReplyEditor,
            pageMode: "view",
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            topLevelCommentId: parentComment.id,
            shouldWarnOnInternalNavigation: true,
            onCancelComment: ({ destroy: destroy = false } = {})=>{
                // when the transition happens the
                // other reply list item is clicked
                // and we need to reset ssetReplyToCommentId
                if ((!destroy || replyToCommentId !== parentCommentId) && (0, $9wGTI.fg)('confluence_comment_fix_reply_discard')) setReplyToCommentId();
                else if (!(0, $9wGTI.fg)('confluence_comment_fix_reply_discard')) setReplyToCommentId();
            },
            isCommentsPanel: true,
            wasRemovedByAnotherUser: parentComment.wasRemovedByAnotherUser,
            isOffline: isOffline
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
            mode: "view",
            isCommentsPanel: true,
            isFabricPage: true,
            "data-testid": "comments-panel-new-reply-container"
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? editor : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2'),
            customStyles: customBranchingStyles
        }, editor));
    };
    const renderUpdatedLowerAction = ()=>{
        if (expandReplyEditor && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return renderCommentEditor();
        else if (!isStandaloneComment) return renderReplyButton();
        else return null;
    }; // Make reply containers tabbable for accessibility
    (0, $42omo.useEffect)(()=>{
        if (visibleReplies && visibleReplies.length > 0 && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false)) // Find all reply containers and make them tabbable
        visibleReplies.forEach((reply)=>{
            const replyContainer = document.querySelector(`[data-testid="comment-thread-${parentComment.id}-replies-${reply.id}"]`);
            if (replyContainer instanceof HTMLElement) replyContainer.setAttribute('tabIndex', '0');
        });
    }, [
        visibleReplies,
        parentComment.id
    ]);
    const renderRepliesToggler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58Zuw.RepliesToggler), {
            replies: allReplies,
            setVisibleReplies: setVisibleRepliesWrapper,
            unreadReplyIds: unreadReplyIds,
            setReplyView: setReplyView,
            threadKey: threadKey,
            currentReplyView: currentReplyView,
            numOfHiddenReplies: numOfHiddenReplies,
            commentType: commentType,
            parentCommentId: parentCommentId,
            isParentOpen: isParentCommentOpen,
            canAddComments: canAddComments,
            shouldShowLatestReplies: shouldShowLatestReplies,
            setShouldShowLatestReplies: setShouldShowLatestReplies,
            latestReplyIds: latestReplyIds,
            isStandaloneComment: isStandaloneComment,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
            expandReplyEditor: expandReplyEditor
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, numOfReplies > 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && renderRepliesToggler(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-replies`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19bvpxbi _u5f3u2gc",
            parentComment.wasRemovedByAnotherUser && "_tzy41ssb",
            isStandaloneComment && "_u5f3pxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, numOfReplies > 0 && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && renderRepliesToggler(), visibleReplies && visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-reply-list`,
        className: (0, $gMc0m.default)([
            !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_1kl71uh4 _bozgze3t"
        ])
    }, visibleReplies.map((reply, idx)=>reply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: reply.id,
            "data-testid": `comment-thread-${parentComment.id}-replies-${reply.id}`,
            onMouseEnter: ()=>handleMouseEnter(reply.id),
            onMouseLeave: handleMouseLeave,
            onFocus: (event)=>handleFocus(event, reply.id),
            onBlur: handleBlur,
            "aria-label": formatMessage($ff4f83a3b963012b$var$i18n.replyAriaLabel, {
                authorName: reply.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
                timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                    intl: intl,
                    dateString: reply.createdAtNonLocalized,
                    isReply: true
                })
            }),
            className: (0, $gMc0m.default)([
                (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? "_qtt8glyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bv1ejb" : "_qtt8glyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bvpxbi",
                (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_ca0qze3t _19bvze3t _n3tdze3t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tfnI.Comment), {
            comment: reply,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? unreadCommentIDSet.has(reply.id) : !commentsMarkedAsRead[commentType][threadKey]?.has(reply.id) && reply.isUnread,
            isHovered: hoveredCommentId === reply.id || commentIsFocused === reply.id && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false),
            threadKey: threadKey,
            hideBranchingStyle: !canAddComments && idx === visibleReplies.length - 1 || isStandaloneComment && idx === visibleReplies.length - 1 || idx === visibleReplies.length - 1 && !expandReplyEditor && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
            adjustForNestedReplies: commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            deleteStandaloneComment: deleteStandaloneComment,
            isStandaloneComment: isStandaloneComment,
            replyToComment: replyToComment,
            updateReactionsCacheFn: updateReactionsCacheFn,
            onRendered: onRendered,
            isLastUnnestableReply: idx === visibleReplies.length - 1,
            commentHandlesPadding: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            hasParentMaxHeight: hasParentMaxHeight
        }), commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e558da207609fcd$export$a0769df2292690a8), {
            nestedReplies: topLevelReplyToNestedChildrenMap[reply.id],
            unreadReplyIds: unreadReplyIds,
            targetCommentIdForScroll: reply.id
        }))))), (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLpk8.RepliesFooter), {
        replyView: currentReplyView,
        setReplyView: setReplyView,
        isEditorExpanded: isEditorExpanded,
        isParentCommentOpen: isParentCommentOpen,
        isStandaloneComment: isStandaloneComment,
        handleReplyButtonClick: handleReplyButtonClick,
        numOfVisibleReplies: visibleReplies ? visibleReplies.length : 0,
        isOffline: isOffline,
        scrollToId: threadKey,
        location: (0, $i6UMJ.LocationValue).PANEL
    }, renderCommentEditor()) : renderUpdatedLowerAction()), expandReplyEditor && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && renderCommentEditor());
};
module.exports["CommentReplies"] = $ff4f83a3b963012b$export$c38311e545a763a;

});

parcelRegister("9tfnI", function(module, exports) {
/* Comment.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $86okN = parcelRequire("86okN");


var $9wGTI = parcelRequire("9wGTI");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $8i27m = parcelRequire("8i27m");


var $NYiei = parcelRequire("NYiei");


var $jbF1h = parcelRequire("jbF1h");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bSvtO = parcelRequire("bSvtO");


var $1YPul = parcelRequire("1YPul");


var $8SCD6 = parcelRequire("8SCD6");


var $kmHPt = parcelRequire("kmHPt");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");

var $g0DaR = parcelRequire("g0DaR");


var $ep3mz = parcelRequire("ep3mz");


var $8z9UY = parcelRequire("8z9UY");


var $jkPJy = parcelRequire("jkPJy");


var $3s9yq = parcelRequire("3s9yq");


var $9rE3H = parcelRequire("9rE3H");


var $eg9xl = parcelRequire("eg9xl");


var $liGyh = parcelRequire("liGyh");


var $aUU0C = parcelRequire("aUU0C");


var $k8e76 = parcelRequire("k8e76");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2eC70 = parcelRequire("2eC70");


var $cD1qu = parcelRequire("cD1qu");


var $8WQTF = parcelRequire("8WQTF");


var $cZa7r = parcelRequire("cZa7r");


var $3ejfs = parcelRequire("3ejfs");


var $2i3To = parcelRequire("2i3To");


var $9CnRS = parcelRequire("9CnRS");


var $ftXPY = parcelRequire("ftXPY");


var $87CZC = parcelRequire("87CZC");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $7B9wr = parcelRequire("7B9wr");


var $i6UMJ = parcelRequire("i6UMJ");


var $9FoVw = parcelRequire("9FoVw");


var $aMfLn = parcelRequire("aMfLn");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $en1dX = parcelRequire("en1dX");


var $6hmtW = parcelRequire("6hmtW");


var $5fMeR = parcelRequire("5fMeR");


var $fy5yb = parcelRequire("fy5yb");

const $dbdd2e782e37c476$var$CommentResolveInlineCommentMutation = (0, $eSUdr.default)`mutation CommentResolveInlineCommentMutation($commentId:ID!$resolved:Boolean!){resolveInlineComment(commentId:$commentId resolved:$resolved dangling:false){status resolveProperties{resolved resolvedUser isDangling resolvedFriendlyDate resolvedTime}}}`;
const $dbdd2e782e37c476$var$CommentResolveCommentMutation = (0, $eSUdr.default)`mutation CommentResolveCommentMutation($commentIds:[ID]!$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds cloudId:$cloudId){success commentResolutionStates{commentId resolveProperties{resolvedTime resolvedUser resolvedFriendlyDate}status}errors{message extensions{...on ResolveCommentsMutationErrorExtension{errorType statusCode}__typename}}}}`;
const $dbdd2e782e37c476$var$CommentReopenCommentMutation = (0, $eSUdr.default)`mutation CommentReopenCommentMutation($commentId:ID!$cloudId:ID!){confluence_reopenComment(commentId:$commentId cloudId:$cloudId){success commentResolutionStates{commentId status}errors{message extensions{...on ReopenCommentsMutationErrorExtension{errorType statusCode}__typename}}}}`;
const $dbdd2e782e37c476$var$CommentDeleteInlineCommentMutationWithStepMutation = (0, $eSUdr.default)`mutation CommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}`;
const $dbdd2e782e37c476$var$CommentDeleteInlineCommentMutation = (0, $eSUdr.default)`mutation CommentDeleteInlineCommentMutation($commentIdToDelete:ID!$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete deleteFrom:$deleteFrom)}`;
const $dbdd2e782e37c476$var$CommentDeleteGeneralCommentMutation = (0, $eSUdr.default)`mutation CommentDeleteGeneralCommentMutation($commentIdToDelete:ID!$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete deleteFrom:$deleteFrom)}`;
const $dbdd2e782e37c476$var$i18n = (0, $cgtv4.defineMessages)({
    commentReopenedFlagTitle: {
        id: "comments-panel.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "comments-panel.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    commentReopenCacheUpdateFailedFlagTitle: {
        id: "comments-panel.comment.reopen.cache-update.failed.flag.title",
        defaultMessage: "Failed to update reopened comment. Please refresh the page."
    },
    retryCTA: {
        id: "comments-panel.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    },
    cannotDeleteTitle: {
        id: "comments-panel.could.not.delete.title",
        defaultMessage: "Unable to delete comment"
    }
});
const $dbdd2e782e37c476$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $dbdd2e782e37c476$var$commentWrapperReplyPaddingOverrides = null;
const $dbdd2e782e37c476$var$leftBorderStyle = null; // this component can be used for parent comment and a reply
const $dbdd2e782e37c476$export$4d299b491347818a = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, isHovered: isHovered, threadKey: threadKey, flags: flags, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandaloneComment: isStandaloneComment, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn, onRendered: onRendered, isLastUnnestableReply: isLastUnnestableReply = false, commentHandlesPadding: commentHandlesPadding = false, hasParentMaxHeight: hasParentMaxHeight = false })=>{
    // Store stable references to break circular dependency in useCallback
    const handleResolveCommentRef = (0, $42omo.useRef)(null);
    const handleReopenCommentRef = (0, $42omo.useRef)(null);
    const [editCommentId, setCommentForEdit] = (0, $42omo.useState)('');
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isNewDanglingCommentExperienceEnable = (0, $7B9wr.useIsNewDanglingCommentExperienceEnabled)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { removeUnresolvedInlineComment: removeUnresolvedInlineComment, addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const [{ commentsDataMap: legacyCommentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, deleteParentComment: deleteParentComment, handleRemovingComments: handleRemovingComments, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList }] = (0, $8i27m.useCommentsData)();
    const { setCacheUpdateFailed: setCacheUpdateFailed } = (0, $8i27m.useCommentsDataActions)(); // Get cache operations for new comments data manager
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId || '',
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    }); // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)(); // Use new or legacy data based on experiment
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const [{ updateDocumentFn: updateDocumentFn }] = (0, $1YPul.useUpdateDocument)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentType] = (0, $ep3mz.useContentType)(); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [resolveInlineCommentFn] = (0, $diswb.useMutation)($dbdd2e782e37c476$var$CommentResolveInlineCommentMutation); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [resolveCommentFn] = (0, $diswb.useMutation)($dbdd2e782e37c476$var$CommentResolveCommentMutation);
    const resolveCommentMutationFn = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? resolveCommentFn : resolveInlineCommentFn; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [reopenCommentFn] = (0, $diswb.useMutation)($dbdd2e782e37c476$var$CommentReopenCommentMutation, {
        refetchQueries: // Copied from the existing dialog flow to support standalone experience
        pageMode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? [
            {
                query: (0, $3s9yq.InlineCommentsQuery),
                variables: {
                    pageId: contentId
                }
            }
        ] : []
    }); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [deleteTopLevelRendererInlineCommentFn] = (0, $diswb.useMutation)($dbdd2e782e37c476$var$CommentDeleteInlineCommentMutationWithStepMutation); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [deleteInlineCommentFn] = (0, $diswb.useMutation)($dbdd2e782e37c476$var$CommentDeleteInlineCommentMutation); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [deleteGeneralCommentFn] = (0, $diswb.useMutation)($dbdd2e782e37c476$var$CommentDeleteGeneralCommentMutation); // Get the update functions for the comments data manager - aliased to support the different
    // mutation's different result types
    const { updateCommentInCache: updateInlineCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateResolveCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateReopenCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)(); // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
    const pageId = contentId;
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAt = comment?.createdAt?.value;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0;
    const commentUrl = pageMode === (0, $cD1qu.PageMode).EDIT ? comment?.links?.editui : comment?.links?.webui; // view page and live docs uses the webui field
    const isDatabaseOrWhiteboard = contentType === 'database' || contentType === 'whiteboard';
    const inheritedReactionsData = comment?.reactionsSummary;
    const inlineCommentlocation = comment?.location;
    const footerCommentLocation = comment?.location;
    const commentType = inlineCommentlocation?.type === 'INLINE' ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL;
    const getResolvedProperties = (0, $42omo.useCallback)((type)=>{
        const properties = type === (0, $8i27m.CommentType).INLINE ? inlineCommentlocation?.inlineResolveProperties : footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        inlineCommentlocation,
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties(commentType);
    const annotatedText = inlineCommentlocation?.inlineText || undefined;
    const isCommentRemovedByAnotherUser = comment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    const isDeletedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
    const deleteCommentInCacheOnUpdate = (0, $42omo.useCallback)((removalCommentId, experienceName)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: experienceName,
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]);
    const handleDeleteInlineComment = ()=>{
        // NOTE: The DELETE experience is started in CommentActions.tsx
        const isDangling = resolveProperties?.isDangling;
        const isTopLevelRendererComment = !isDatabaseOrWhiteboard && pageMode === (0, $cD1qu.PageMode).VIEW && !isReply;
        const canDeleteAnnotation = !isDangling && isTopLevelRendererComment;
        let step;
        if (canDeleteAnnotation) try {
            const deleteResult = rendererActions?.deleteAnnotation(threadKey, 'inlineComment');
            if (deleteResult) step = deleteResult.step;
            else {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${threadKey} from document`)
                });
                return;
            }
        } catch (e) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: e
            });
            return;
        }
        if (isStandaloneComment) {
            deleteStandaloneComment && parentCommentId && deleteStandaloneComment(parentCommentId, commentId);
            return;
        }
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) resetContentChanged();
        const deletedInlineParentComment = (0, $fy5yb.deleteInlineParentComment)({
            isReply: isReply,
            threadKey: threadKey,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            deleteParentComment: deleteParentComment
        });
        const deleteMutation = canDeleteAnnotation ? deleteTopLevelRendererInlineCommentFn : deleteInlineCommentFn;
        const deleteVariables = {
            variables: canDeleteAnnotation ? {
                input: {
                    commentId: commentId,
                    step: step ? (0, $aMfLn.constructStepForGql)(step) : {}
                }
            } : {
                commentIdToDelete: commentId,
                // There is no VIEW option
                deleteFrom: pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId, (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)), ()=>isReply ? (0, $g0DaR.updateApolloCacheCallback)('delete', {
                    pageId: pageId,
                    contentStatus: [
                        'CURRENT',
                        'DRAFT'
                    ]
                }, parentCommentId, commentId) : undefined)
        };
        deleteMutation({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || canDeleteAnnotation && !data.deleteInlineComment || !canDeleteAnnotation && !data.deleteComment) throw new Error('No data returned from mutation');
            const cleanUpReply = ()=>{
                handleRemovingComments({
                    threadKey: threadKey,
                    commentId: commentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: commentType
                });
            };
            const deleteAnnotationAndCleanUpParent = (annotationId)=>{
                // For a top level comment in renderer, we need to send out the events to tell the
                // renderer to deselect the annotation and remove it from the document
                if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const deleteResult = rendererActions?.deleteAnnotation(annotationId, 'inlineComment');
                    if (deleteResult && deleteResult.doc) {
                        // Inform the Renderer to de-select the annotation
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                        updateDocumentFn && updateDocumentFn(deleteResult.doc);
                    } // For editor/live pages we need to send the event to delete the mark
                } else eventEmitter.emit('delete', annotationId);
                if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    resetContentChanged();
                    deleteParentComment({
                        threadKey: threadKey,
                        commentType: commentType
                    });
                    if (commentType === (0, $8i27m.CommentType).INLINE) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey));
                }
            }; // send bridge api signal to content types.
            commentService.onDeleteComment?.(threadKey);
            const onSuccess = (annotationId)=>{
                if (isReply) cleanUpReply();
                else deleteAnnotationAndCleanUpParent(annotationId);
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: commentId,
                annotationId: threadKey,
                pageId: pageId,
                pageMode: pageMode,
                isReply: isReply,
                source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                inlineNodeTypes: undefined,
                createAnalyticsEvent: // We need to figure out how to get this data
                createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: onSuccess
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags?.showWarningFlag({
                        id: commentId,
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $dbdd2e782e37c476$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                            attributes: {
                                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                                commentType: (0, $8i27m.CommentType).INLINE,
                                mode: pageMode,
                                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            if (deletedInlineParentComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) addNewCommentThreads(deletedInlineParentComment);
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: err,
                commentId: commentId
            });
        });
    };
    const handleDeleteGeneralComment = ()=>{
        let deleteLocation; // There is no deleteLocation for View Page
        if (pageMode !== (0, $cD1qu.PageMode).VIEW) deleteLocation = pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE;
        const queryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
            pageId: pageId,
            type: 'FOOTER' // If we have footer, always write to footer. Panel works either way
        });
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId, (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)), ()=>isReply ? (0, $87CZC.updateApolloCacheReplyCallback)('delete', queryVariables, parentCommentId, isReactionsEnabled, commentId) : (0, $87CZC.updateApolloCacheParentCallback)('delete', queryVariables, isReactionsEnabled, commentId))
        };
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            if (isReply) handleRemovingComments({
                threadKey: threadKey,
                commentId: commentId,
                action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                commentType: commentType
            });
            else deleteParentComment({
                threadKey: threadKey,
                commentType: commentType
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        isReply: isReply,
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        pageMode: pageMode
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags?.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $dbdd2e782e37c476$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                            attributes: {
                                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                                commentType: (0, $8i27m.CommentType).GENERAL,
                                mode: pageMode,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                error: err,
                commentId: commentId
            });
        });
    };
    const handleEditComment = ()=>{
        setCommentForEdit(commentId);
    };
    const exitCommentEditor = ()=>{
        setCommentForEdit('');
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).PANEL,
            user: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            } : undefined
        });
    };
    const handleReopenMutationFailure = (0, $42omo.useCallback)(({ isCacheUpdateFailed: isCacheUpdateFailed })=>{
        // TODO: Add experience tracking for reopening, which will allow us to differentiate and
        // detect cache errors vs mutation errors by the error value in the stopOnError() experience
        // call.  When that is added, we can go back to having a single flag message.
        flags?.showErrorFlag({
            id: commentId,
            title: formatMessage(isCacheUpdateFailed ? $dbdd2e782e37c476$var$i18n.commentReopenCacheUpdateFailedFlagTitle : $dbdd2e782e37c476$var$i18n.commentReopenFailedFlagTitle),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage($dbdd2e782e37c476$var$i18n.retryCTA),
                    onClick: ()=>{
                        flags.hideFlag(flags.state.flags[0]?.id);
                        handleReopenCommentRef.current?.();
                    }
                }
            ]
        });
    }, [
        commentId,
        flags,
        formatMessage
    ]);
    const reopenCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateReopenCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.reopenCommentInCacheCallback),
            onError: ()=>handleReopenMutationFailure({
                    isCacheUpdateFailed: true
                })
        }), [
        commentId,
        handleReopenMutationFailure,
        updateReopenCommentInCache
    ]);
    const handleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            },
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? reopenCommentUpdateFn : undefined
        }).then(()=>{
            // Update the list of active annotationIds
            addUnresolvedInlineComment(threadKey, pageMode); // Emit the event to editor/renderer to reactivate the annotationId
            if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) {
                if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                        [threadKey]: {
                            id: threadKey,
                            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                            state: (0, $cUycv.AnnotationMarkStates).ACTIVE
                        }
                    });
                } else {
                    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                    emitter.emit('unresolve', threadKey);
                }
            } // Update the state for panel experience
            const commentsDataMapClone = {
                ...commentsDataMap
            };
            const commentInMap = commentsDataMapClone[commentType][threadKey];
            if (commentInMap) {
                commentInMap.isOpen = true;
                commentInMap.wasRemovedByAnotherUser = false;
                const commentLocation = commentInMap.location;
                if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = false;
                if (commentLocation && 'inlineResolveProperties' in commentLocation && commentLocation.inlineResolveProperties && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // make sure this is false too just in case
                commentLocation.inlineResolveProperties.resolved = false;
                addNewCommentThreads(commentsDataMapClone);
            } // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($dbdd2e782e37c476$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            const isDangling = inlineCommentlocation?.inlineResolveProperties?.isDangling;
                            let currentViewValue = undefined; // just in case the user closed the panel after flag is displayed but before the action is taken, we'll want to reopen the panel again
                            // TOFIX: isCommentsPanelShown is still true after the panel is closed so we'll omit this check for now
                            if (isDangling && isNewDanglingCommentExperienceEnable) {
                                if (!(0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                                    showCommentsPanel({
                                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    currentViewValue = (0, $3mVfX.ViewValues).DELETED_CONTENT;
                                } else {
                                    setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                    currentViewValue = (0, $3mVfX.ViewValues).DELETED_CONTENT;
                                }
                            } else if (isCommentsPanelShown && (0, $9wGTI.fg)('confluence_comments_fix_vqr_fliter_scroll')) {
                                setCurrentView((0, $3mVfX.ViewValues).OPEN);
                                currentViewValue = (0, $3mVfX.ViewValues).OPEN;
                            } // Call navigation with view change waiting for reopen flow
                            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
                                annotationClicked: true,
                                expectedView: currentViewValue
                            });
                            if (commentType === (0, $8i27m.CommentType).INLINE) {
                                setCurrentlySelectedThreadKey(threadKey); // scrollCommentsPanelToThread will handle changing views as well
                                !(0, $9wGTI.fg)('confluence_comments_unified_navigation') && scrollCommentsPanelToThread((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
                                    annotationId: threadKey,
                                    annotationClicked: true,
                                    isCommentThreadDangling: isDangling
                                } : {
                                    annotationId: threadKey,
                                    isCommentThreadDangling: isDangling
                                });
                            } else if (commentType === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence_comments_fix_vqr_fliter_scroll')) {
                                setCurrentlySelectedThreadKey(threadKey);
                                !(0, $9wGTI.fg)('confluence_comments_unified_navigation') && scrollCommentsPanelToThread({
                                    annotationId: threadKey,
                                    commentType: commentType,
                                    scrollOnLoad: true
                                });
                            }
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            if (commentType === (0, $8i27m.CommentType).INLINE) {
                if (isDatabaseOrWhiteboard && (0, $9wGTI.fg)('cc-whiteboards-consolidating-comments')) {
                    // add unresolved comment to whiteboard and database
                    const commentLocation = commentInMap.location;
                    commentService.onReopenResolvedComment?.({
                        contentId: pageId,
                        referenceId: commentLocation.inlineMarkerRef
                    });
                }
                const orderedActiveAnnotationIds = orderedActiveAnnotationIdList.map((annotation)=>annotation.threadKey); // only insert reopened comment annotation if the comment highlight exists
                if (!resolveProperties?.isDangling) {
                    let annotationsList = annotations;
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                        const annotationMarks = rendererActions?.getAnnotationMarks();
                        annotationsList = annotationMarks?.map((mark)=>mark.attrs.id) ?? [];
                    }
                    if (annotationsList.length > 0) (0, $g0DaR.insertReopenedCommentAnnotation)(annotationsList, threadKey, orderedActiveAnnotationIds, setOrderedActiveAnnotationIdList);
                }
            }
        }).catch(()=>{
            handleReopenMutationFailure({
                isCacheUpdateFailed: false
            });
        });
    };
    const resolveExperienceName = commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE);
    const handleResolveMutationFailure = (0, $42omo.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: resolveExperienceName,
            error: resolveError
        });
    }, [
        experienceTracker,
        resolveExperienceName
    ]);
    const resolveInlineCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateInlineCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateInlineCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const resolveCommentsUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateResolveCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateResolveCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    let commentsDataManagerResolveUpdateFn = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) commentsDataManagerResolveUpdateFn = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? resolveCommentsUpdateFn // FG enables new BE resolve comments endpoint
     : resolveInlineCommentUpdateFn; // use legacy inline comment resolve endpoint if not FG
    const handleResolveComment = ()=>{
        const mutationVariables = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? {
            commentIds: [
                commentId
            ],
            cloudId: cloudId
        } : {
            commentId: commentId,
            resolved: true
        };
        const query = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $eg9xl.ActiveCommentsQuery) : (0, $jkPJy.CommentsPanelQuery);
        const queryVariables = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
            pageId: pageId,
            type: commentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : undefined // If we have footer, always write to footer. Panel works either way
        }) : {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            first: (0, $9wGTI.fg)('confluence_frontend_comments_1k_batch_size') ? 1000 : 250
        }; // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentMutationFn({
            variables: mutationVariables,
            update: commentsDataManagerResolveUpdateFn || ((cache, { data: data })=>{
                // readQuery can still return null which complicates TS lint errors with optional chaining
                // once we move to v3 of the apollo client we can move to cache.modify
                try {
                    const dataProxy = cache.readQuery({
                        query: (0, $86okN.toDocumentNode)(query),
                        variables: queryVariables
                    });
                    const commentsToWrite = Object.assign({}, dataProxy?.comments);
                    let totalCount = commentsToWrite.totalCount || 0;
                    const commentsList = commentsToWrite.nodes?.filter((n)=>n !== null);
                    const idxToRemove = commentsList.findIndex((c)=>c.id === commentId); // Remove the newly resolved comment from the list if we can find it
                    if (idxToRemove !== -1) {
                        commentsList.splice(idxToRemove, 1);
                        totalCount--;
                    }
                    cache.writeQuery({
                        query: (0, $86okN.toDocumentNode)(query),
                        variables: queryVariables,
                        data: {
                            comments: {
                                nodes: commentsList,
                                totalCount: totalCount
                            }
                        }
                    }); // cache updated successfuly
                    // now check if previous cache update was failed
                    if (cacheUpdateFailed) setCacheUpdateFailed(false);
                } catch (err) {
                    $dbdd2e782e37c476$var$logger.error`An error occurred when updating cache for comments panel resolve - ${err}`;
                    setCacheUpdateFailed(true);
                }
                if (!isReply && comment.type === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) try {
                    const { confluence_resolveComments: { commentResolutionStates: commentResolutionStates, success: success } } = data;
                    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
                    if (!success || commentResolutionStates.length === 0) return;
                    const { commentId: commentId } = commentResolutionStates[0];
                    const prevData = cache.readQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        }
                    });
                    const edges = prevData?.comments?.edges; // Filter out all comments related to the parent and it's children as they will all be resolved
                    const newEdges = edges?.filter((edge)=>edge?.node?.id !== commentId && !edge?.node?.ancestors.map((a)=>a?.id).includes(commentId)) || [];
                    const newData = {
                        comments: {
                            ...prevData?.comments,
                            totalCount: newEdges.length,
                            pageInfo: {
                                ...prevData?.comments?.pageInfo,
                                endCursor: '',
                                hasNextPage: false //set hasNextPage to always false to avoid performing incremental fetching again which will result in duplicate data
                            },
                            edges: newEdges
                        },
                        content: {
                            ...prevData?.content,
                            nodes: [
                                ...prevData?.content?.nodes || []
                            ]
                        },
                        user: {
                            ...prevData?.user
                        }
                    };
                    cache.writeQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...newData
                        }
                    });
                } catch (err) {
                    $dbdd2e782e37c476$var$logger.error`An error occurred when updating cache for general comments resolve - ${err}`;
                    setCacheUpdateFailed(true);
                }
            })
        }).then(()=>{
            // Update the state for panel experience
            const commentsDataMapClone = {
                ...commentsDataMap
            };
            const commentInMap = commentsDataMapClone[commentType][threadKey];
            if (commentInMap) {
                commentsDataMapClone[commentType][threadKey].isOpen = false;
                const commentLocation = commentsDataMapClone[commentType][threadKey].location;
                if (commentLocation && commentLocation.inlineResolveProperties) commentLocation.inlineResolveProperties.resolved = true;
                if (commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = true;
                addNewCommentThreads(commentsDataMapClone);
            } // Update content types comment service if we are resolving a comment
            commentService.onResolveComment?.(threadKey);
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: pageId,
                pageMode: pageMode,
                commentType: commentType,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                setEditorViewProps: setEditorViewProps //getInlineNodeTypes  // TODO: Figure out how to get this info
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey)); // Show the resolved flag
            if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            !(0, $9wGTI.fg)('confluence_comments_unified_navigation') && scrollCommentsPanelToThread({
                                annotationId: threadKey,
                                scrollOnLoad: (0, $9wGTI.fg)('confluence_comments_fix_vqr_fliter_scroll')
                            });
                            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            handleReopenComment();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: resolveExperienceName
            });
        }).catch((err)=>{
            handleResolveMutationFailure(err);
        });
    };
    const handleStandaloneReply = (id)=>{
        replyToComment && replyToComment(id, comment);
    }; // Update refs to break circular dependency
    handleResolveCommentRef.current = handleResolveComment;
    handleReopenCommentRef.current = handleReopenComment;
    const pageType = pageInfo?.type ?? ''; // Editor setup
    const spaceId = pageInfo?.space?.id ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType); // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const supportedActions = !isReply && isCommentRemovedByAnotherUser ? [
        'reopen'
    ] : supportedTopLevelActions;
    const shouldShowLeftBorder = commentHandlesPadding && !isStandaloneComment && commentId === editCommentId && isReply;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            commentHandlesPadding && "_19bv1ejb _n3tdu2gc",
            shouldShowLeftBorder && "_1kl711qs"
        ])
    }, commentId === editCommentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
        pageId: pageId,
        pageType: pageType,
        annotationId: threadKey,
        commentId: commentId,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        resolveProperties: resolveProperties,
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isCommentsPanel: isCommentsPanelShown,
        commentType: commentType,
        isStandaloneComment: isStandaloneComment,
        isOffline: isOffline,
        isLastUnnestableReply: isLastUnnestableReply,
        hasParentMaxHeight: hasParentMaxHeight
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAt: createdAt ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        pageId: pageId,
        pageType: pageType,
        commentId: commentId ?? '',
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedActions,
        deleteComment: commentType === (0, $8i27m.CommentType).INLINE ? handleDeleteInlineComment : handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        isCommentsPanel: true,
        isHovered: isHovered,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        isFocused: isCommentFocused,
        isOffline: isOffline,
        resolveProperties: resolveProperties,
        annotationId: threadKey,
        annotatedText: annotatedText,
        reopenComment: handleReopenComment,
        replyToComment: isStandaloneComment ? handleStandaloneReply : handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        isAnnotatedTextPressed: isAnnotatedTextPressed,
        setAnnotatedTextPressed: setAnnotatedTextPressed,
        commentType: commentType,
        adjustForNestedReplies: adjustForNestedReplies,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered,
        isParentCommentOpen: isParentCommentOpen,
        reactionsCacheUpdateFn: updateReactionsCacheFn,
        isStandaloneComment: isStandaloneComment,
        onRendered: onRendered
    }));
};
module.exports["Comment"] = $dbdd2e782e37c476$export$4d299b491347818a;

});

parcelRegister("1YPul", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $77145f754114b981$export$d4c72bab9d6cc13a = {
    updateDocumentFn: ()=>{}
};
const $77145f754114b981$export$e324594224ef24da = {
    setUpdateDocumentFn: (newUpdateDocumentFn)=>({ setState: setState })=>{
            setState({
                updateDocumentFn: newUpdateDocumentFn
            });
        }
};
const $77145f754114b981$export$bca0c556b0ff9d9c = (0, $1P1Tu.createStore)({
    initialState: $77145f754114b981$export$d4c72bab9d6cc13a,
    actions: $77145f754114b981$export$e324594224ef24da,
    name: 'UpdateDocumentStore'
});
const $77145f754114b981$export$5e7505d6571fe99d = (0, $9zUhf.createHook)($77145f754114b981$export$bca0c556b0ff9d9c);
const $77145f754114b981$export$25ca074c0dbf9075 = (0, $9zUhf.createActionsHook)($77145f754114b981$export$bca0c556b0ff9d9c);
module.exports["useUpdateDocument"] = $77145f754114b981$export$5e7505d6571fe99d;
module.exports["useUpdateDocumentActions"] = $77145f754114b981$export$25ca074c0dbf9075;

});

parcelRegister("2UZkz", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $7EEGh = parcelRequire("7EEGh");


var $6f0Oj = parcelRequire("6f0Oj");


var $9QIM2 = parcelRequire("9QIM2");


var $dANtQ = parcelRequire("dANtQ");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $7aw3q = parcelRequire("7aw3q");


var $g1WP0 = parcelRequire("g1WP0");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");

/**
 * @graphql cc
 */ 









var $9wGTI = parcelRequire("9wGTI");




const $64740e0452ba9207$export$edb9b52ab3f1abbb = ({ refs: refs, shouldSkip: shouldSkip = false })=>{
    const [visibleIds, setVisibleIds] = (0, $42omo.useState)(new Set());
    const options = (0, $42omo.useRef)({
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    });
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (shouldSkip || !refs.every(({ ref: ref })=>ref.current)) // Not all elements are mounted yet, exit early
        return;
        // eslint-disable-next-line
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // Find the corresponding ref based on the entry target
                const refObject = refs.find(({ ref: ref })=>ref.current === entry.target);
                // If the corresponding ref is not found, don't do anything
                if (!refObject) return;
                setVisibleIds((prev)=>{
                    const newVisibleIds = new Set(prev);
                    const idExists = newVisibleIds.has(refObject.id);
                    if (entry.isIntersecting) // ensure id is not already in the list before adding
                    {
                        if (!idExists) newVisibleIds.add(refObject.id);
                    } else // remove id from list if it's no longer visible
                    if (idExists) newVisibleIds.delete(refObject.id);
                    return newVisibleIds;
                });
            });
        }, options.current);
        refs.forEach(({ ref: ref })=>{
            // only observe if the element is in the dom
            if (ref.current) observer.observe(ref.current);
        });
        // clean up observer when component unmounts
        return ()=>{
            observer.disconnect();
        };
    }, [
        refs,
        shouldSkip
    ]);
    return visibleIds;
};



var $dPJCf = parcelRequire("dPJCf");


var $aHcFH = parcelRequire("aHcFH");


var $fHAwL = parcelRequire("fHAwL");

const $fa00cbfae0fc22e0$export$a0ea1ecb643035a5 = ({ commentData: commentData, isEditor: isEditor, focusedCommentId: focusedCommentId, shouldCollapseReplies: shouldCollapseReplies, setIsReplyChainCollapsed: setIsReplyChainCollapsed, isInlineCommentVisible: isInlineCommentVisible, onUpdateUnreadStatus: onUpdateUnreadStatus })=>{
    const [{ unreadCommentsListState: unreadCommentsListState, readCommentsListState: readCommentsListState }, { updateUnreadCommentsListState: updateUnreadCommentsListState, updateReadCommentsListState: updateReadCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const useUnreadCommentsQueryParam = (0, $dPJCf.createSingleQueryParamHook)('unreadCommentMark');
    const unreadCommentMark = useUnreadCommentsQueryParam();
    // this will show the unread badge for unread comments
    const [currentUnreadIds, setCurrentUnreadIds] = (0, $42omo.useState)(new Set());
    const isUnreadComment = (0, $42omo.useCallback)((commentIdToCheck, readComments)=>{
        return !readComments.has(commentIdToCheck);
    }, []);
    const [markInlineCommentsRead, { error: markCommentReadError }] = (0, $diswb.useMutation)((0, $eSUdr.default)`mutation useUnreadCommentsForInlineCommentMarkInlineCommentsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`);
    // store the top level comment and replies into a ref array so we can check if they are unread and in viewport
    const commentRefArray = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        commentRefArray.current = commentRefArray.current.slice(0, (commentData?.replies?.length || 0) + 1);
    }, [
        commentData
    ]);
    const unreadCommentRefs = (0, $42omo.useMemo)(()=>{
        // Filter out read comments
        const unreadComments = [
            commentData?.id,
            ...commentData?.replies?.map((reply)=>reply?.id) || []
        ].filter((id)=>id && isUnreadComment(id, readCommentsListState));
        return unreadComments.map((id, i)=>{
            var _commentRefArray_current, _i;
            return {
                ref: (_commentRefArray_current = commentRefArray.current)[_i = i] || (_commentRefArray_current[_i] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef()),
                id: id ?? ''
            };
        });
    }, [
        commentData,
        isUnreadComment,
        readCommentsListState
    ]);
    const unreadVisibleCommentIds = (0, $64740e0452ba9207$export$edb9b52ab3f1abbb)({
        refs: unreadCommentRefs,
        shouldSkip: currentUnreadIds.size === 0
    });
    // handle unread comments/replies display
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (commentData) {
            const allCommentIds = new Set();
            allCommentIds.add(commentData.id);
            commentData.replies?.forEach((reply)=>{
                if (reply) allCommentIds.add(reply.id);
            });
            const currentThreadUnreadCommentIds = new Set();
            const filteredUnreadComments = unreadCommentsListState.filter((unreadComment)=>{
                const isUnreadCommentInCommentIds = allCommentIds.has(unreadComment.id);
                if (isUnreadCommentInCommentIds) currentThreadUnreadCommentIds.add(unreadComment.id);
                return !isUnreadCommentInCommentIds;
            });
            // Update the state with the filtered unread comments
            updateUnreadCommentsListState(()=>filteredUnreadComments);
            setCurrentUnreadIds(currentThreadUnreadCommentIds);
            if (currentThreadUnreadCommentIds.size) {
                const newReadCommentsListState = new Set([
                    ...readCommentsListState,
                    ...currentThreadUnreadCommentIds
                ]);
                updateReadCommentsListState(()=>newReadCommentsListState);
                markInlineCommentsRead({
                    variables: {
                        commentIds: [
                            ...currentThreadUnreadCommentIds
                        ]
                    }
                });
                onUpdateUnreadStatus(currentThreadUnreadCommentIds);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentData
    ]);
    // handle updating unread count and state
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (commentData) {
            // only mark the comments/replies in view as read and update unread/read lists accordingly
            const commentsToMarkRead = new Set();
            if (unreadVisibleCommentIds.size) updateUnreadCommentsListState((prev)=>{
                return prev.filter((unreadComment)=>{
                    if (unreadVisibleCommentIds.has(unreadComment.id)) {
                        commentsToMarkRead.add(unreadComment.id);
                        return false;
                    }
                    return true;
                });
            });
            commentsToMarkRead.size;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- updateUnreadCommentsListState in the dependency array will cause unnecessary re-renders
    }, [
        commentData,
        unreadVisibleCommentIds
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (shouldCollapseReplies && commentData?.replies?.length) {
            const hiddenReplies = commentData?.replies.slice(0, -1);
            if (hiddenReplies && hiddenReplies.find((reply)=>reply && currentUnreadIds.has(reply.id))) setIsReplyChainCollapsed(false);
        }
    }, [
        commentData?.replies,
        currentUnreadIds,
        shouldCollapseReplies,
        setIsReplyChainCollapsed
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        const markerRef = commentData?.location?.inlineMarkerRef;
        if (unreadCommentMark === markerRef && !focusedCommentId && currentUnreadIds.size && isInlineCommentVisible) {
            const [firstUnreadId] = currentUnreadIds;
            (0, $aHcFH.handleScrollToElement)({
                commentId: firstUnreadId,
                targetCommentId: firstUnreadId,
                isEditor: Boolean(isEditor),
                viewingRoomOffset: -300
            });
        }
    }, [
        currentUnreadIds,
        focusedCommentId,
        isEditor,
        commentData?.location,
        unreadCommentMark,
        isInlineCommentVisible
    ]);
    return {
        unreadCommentRefs: unreadCommentRefs,
        currentUnreadIds: currentUnreadIds,
        markCommentReadError: markCommentReadError
    };
};






var $b3j2Y = parcelRequire("b3j2Y");


var $24amZ = parcelRequire("24amZ");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cZa7r = parcelRequire("cZa7r");


var $b8XTE = parcelRequire("b8XTE");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $cQCqE = parcelRequire("cQCqE");


var $jbF1h = parcelRequire("jbF1h");


var $kgNLQ = parcelRequire("kgNLQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $8Ss4E = parcelRequire("8Ss4E");


var $2eC70 = parcelRequire("2eC70");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $aGjYc = parcelRequire("aGjYc");


var $liGyh = parcelRequire("liGyh");


var $hXzKU = parcelRequire("hXzKU");


var $8z9UY = parcelRequire("8z9UY");


var $afGoD = parcelRequire("afGoD");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $lb2Lp = parcelRequire("lb2Lp");














var $8i27m = parcelRequire("8i27m");


var $7W8i8 = parcelRequire("7W8i8");


var $9CnRS = parcelRequire("9CnRS");

const $6153444078ddb7dc$var$logger = (0, $7W8i8.getLogger)('annotation-provider-inline-comment');
const $6153444078ddb7dc$export$ddce50f11b36de55 = (dependencies)=>{
    const { reopenInlineCommentFn: reopenInlineCommentFn, getUpdateFn: getUpdateFn, commentId: commentId, annotationId: annotationId, reopenParentComment: reopenParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, highlightReopenedComment: highlightReopenedComment, isEditor: isEditor, eventEmitter: eventEmitter, setActiveHighlight: setActiveHighlight, experienceTracker: experienceTracker } = dependencies;
    return ()=>{
        return reopenInlineCommentFn({
            variables: {
                commentId: commentId,
                resolved: false
            },
            update: getUpdateFn?.((cacheError)=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                    error: cacheError
                });
            })
        }).then(()=>{
            reopenParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            setOrderedActiveAnnotationIdList([
                ...orderedActiveAnnotationIdList.map((status)=>status.threadKey),
                annotationId
            ]);
            highlightReopenedComment(annotationId);
            if (isEditor) {
                eventEmitter.emit('unresolve', annotationId);
                eventEmitter.emit('setselectedannotation', annotationId);
            } else {
                const commentElement = document.getElementById(annotationId);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: commentElement
                });
                setActiveHighlight(annotationId);
            }
            experienceTracker.succeed({
                name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            $6153444078ddb7dc$var$logger.error`An error occurred when reopening a comment ${err}`;
            experienceTracker.stopOnError({
                name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                error: err
            });
        });
    };
};
const $6153444078ddb7dc$export$c71830b449cacdd = ({ commentId: commentId, experienceTracker: experienceTracker, flags: flags, mode: mode, annotationId: annotationId, handleReopenComment: handleReopenComment, formatMessage: formatMessage, showCommentsPanel: showCommentsPanel, setCurrentView: setCurrentView, scrollCommentsPanelToThread: scrollCommentsPanelToThread, isCommentsPanelShown: isCommentsPanelShown, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey })=>{
    flags?.showSuccessCircleFlag({
        id: commentId,
        title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
        isAutoDismiss: true,
        actions: [
            {
                content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                onClick: ()=>{
                    if (!isCommentsPanelShown) {
                        setCurrentlySelectedThreadKey(annotationId);
                        showCommentsPanel({
                            openWithView: (0, $3mVfX.ViewValues).RESOLVED
                        });
                        scrollCommentsPanelToThread?.({
                            annotationId: annotationId,
                            annotationClicked: true
                        });
                    } else {
                        setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                        scrollCommentsPanelToThread?.({
                            annotationId: annotationId
                        });
                    }
                    flags.hideFlag(flags.state.flags[0]?.id);
                }
            },
            {
                content: formatMessage((0, $9CnRS.i18n).undoCTA),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                        id: commentId,
                        attributes: {
                            mode: mode,
                            framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                            annotationId: annotationId
                        }
                    });
                    handleReopenComment();
                    flags.hideFlag(flags.state.flags[0]?.id);
                }
            }
        ]
    });
};



var $8wupW = parcelRequire("8wupW");


var $c7FK0 = parcelRequire("c7FK0");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $daq5m = parcelRequire("daq5m");





var $cD1qu = parcelRequire("cD1qu");


var $g0DaR = parcelRequire("g0DaR");

var $asNlu = parcelRequire("asNlu");

var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");


var $666Tc = parcelRequire("666Tc");





var $3ejfs = parcelRequire("3ejfs");





var $aMfLn = parcelRequire("aMfLn");


var $k8e76 = parcelRequire("k8e76");


var $3jwuS = parcelRequire("3jwuS");





var $cAdj8 = parcelRequire("cAdj8");


var $3ZsvI = parcelRequire("3ZsvI");





var $hl0fg = parcelRequire("hl0fg");


var $7Sm4c = parcelRequire("7Sm4c");


var $en1dX = parcelRequire("en1dX");


var $7aRa9 = parcelRequire("7aRa9");


var $4Svbr = parcelRequire("4Svbr");


var $7qvmT = parcelRequire("7qvmT");


var $5fMeR = parcelRequire("5fMeR");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $a3q17 = parcelRequire("a3q17");


var $bEwJH = parcelRequire("bEwJH");


var $B3Avz = parcelRequire("B3Avz");

const $f4f7ab8b4171ff8f$var$relativeFilePath = 'annotation-provider-inline-comments/InlineComment';
// Note this mutation can be used for resolving or reopening comments, depending on the value
// of the `$resolved` variable passed to it.
// TODO: Refactor to use the newer and separate `confluence_resolveComments()` and
// `confluence_reopebComment()` mutations.
const $f4f7ab8b4171ff8f$var$InlineCommentResolveInlineCommentMutation = (0, $eSUdr.default)`mutation InlineCommentResolveInlineCommentMutation($commentId:ID!$resolved:Boolean!){resolveInlineComment(commentId:$commentId resolved:$resolved dangling:false){status resolveProperties{resolved resolvedUser isDangling resolvedFriendlyDate resolvedTime}}}`;
const $f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutation = (0, $eSUdr.default)`mutation InlineCommentDeleteInlineCommentMutation($commentIdToDelete:ID!$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete deleteFrom:$deleteFrom)}`;
const $f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutationWithStepMutation = (0, $eSUdr.default)`mutation InlineCommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}`;
const $f4f7ab8b4171ff8f$var$InlineCommentCreateInlineReplyMutation = (0, $eSUdr.default)`mutation InlineCommentCreateInlineReplyMutation($input:ReplyInlineCommentInput!$pageId:ID!$includeReactions:Boolean!){replyInlineComment(input:$input){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactions){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}`;
const $f4f7ab8b4171ff8f$var$i18n = (0, $cgtv4.defineMessages)({
    cannotDeleteTitle: {
        id: "annotation-provider-inline-comments.could.not.delete.title",
        defaultMessage: "Unable to delete comment"
    },
    commentLoadError: {
        id: "annotation-provider-inline-comments.error.comment.load.message",
        defaultMessage: "Something went wrong when loading this comment. Refresh to view the latest updates."
    },
    commentLoadNetworkError: {
        id: "annotation-provider-inline-comments.network.error.message",
        defaultMessage: "This comment wasn't loaded due to a network error. Check your connection and try again."
    },
    commentLoadErrorTitle: {
        id: "annotation-provider-inline-comments.error.comment.load.title",
        defaultMessage: "Unable to load comment"
    },
    commentReplyAriaLabel: {
        id: "annotation-provider-inline-comments.comment.reply.aria-label",
        defaultMessage: "Reply to {name}\u2019s thread"
    },
    commentAriaLabel: {
        id: "annotation-provider-inline-comments.comment.aria-label",
        defaultMessage: "Comment by {displayName}, {timestamp}"
    }
});
const $f4f7ab8b4171ff8f$var$logger = (0, $7W8i8.getLogger)('annotation-provider-inline-comment');
const $f4f7ab8b4171ff8f$var$InlineCommentComponent = ({ annotation: selectedAnnotation, onResolve: onResolve, deleteOptions: deleteOptions, onClose: onClose, isEditor: isEditor, isArchived: isArchived, onNavigationClick: onNavigationClick, onDelete: onDelete, supportedTopLevelActions: supportedTopLevelActions, getInlineNodeTypes: getInlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, inlineCommentRef: inlineCommentRef = ()=>{}, isInlineCommentVisible: isInlineCommentVisible = false, flags: flags, isOffline: isOffline })=>{
    const pageClass = (0, $9QIM2.usePageClass)();
    const lastSelected = (0, $42omo.useRef)(undefined);
    const { replyToCommentUser: replyToCommentUser } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setReplyToCommentId: setReplyToCommentId, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentQueryId } = (0, $liGyh.useInlineCommentQueryParams)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const RENDER_METRIC = isEditor ? (0, $a3q17.EDITOR_INLINE_COMMENT_RENDER_METRIC) : (0, $a3q17.RENDERER_INLINE_COMMENT_RENDER_METRIC);
    if (lastSelected.current !== selectedAnnotation.id) {
        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.start({
            ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
            pageClass: pageClass,
            annotationId: selectedAnnotation.id,
            entryPoint: 'unknown:InlineComment'
        });
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) {
            RENDER_METRIC.start();
            const attributes = {
                pageMode: pageMode,
                pageClass: pageClass,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                annotationId: selectedAnnotation.id,
                isEditor: !!isEditor,
                isArchived: !!isArchived,
                isOpeningMediaCommentFromToolbar: !!isOpeningMediaCommentFromToolbar,
                isInlineCommentVisible: !!isInlineCommentVisible,
                isOffline: !!isOffline,
                ...focusedCommentId && {
                    focusedCommentId: focusedCommentId
                },
                ...replyToCommentId && {
                    replyToCommentId: replyToCommentId
                },
                ...editCommentQueryId && {
                    editCommentId: editCommentQueryId
                }
            };
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_extend')) {
                (0, $4EKKB.selectInlineComment).debug(`InlineComment component mounted with annotation id ${selectedAnnotation.id}`);
                experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
            } else experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    ...attributes,
                    entryPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
            if (pageClass !== 'renderer' && pageClass !== 'editor') experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: 'Page class is not renderer or editor',
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        }
        lastSelected.current = selectedAnnotation.id;
    }
    const annotationElementRef = (0, $42omo.useRef)(null);
    const resolveWindowCloseTimeout = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const [eventEmitter] = (0, $42omo.useState)(()=>isEditor ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)());
    const [shouldFocusNewReply, setShouldFocusNewReply] = (0, $42omo.useState)(false);
    // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
    const pageId = contentId;
    const { addUnresolvedInlineComment: addUnresolvedInlineComment, removeUnresolvedInlineComment: removeUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageId);
    const { handleClose: handleClose, setEditorCreateProps: setEditorCreateProps, setHoverProps: setHoverProps, setSelectionProps: setSelectionProps, setStoredCommentData: setStoredCommentData, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const [editCommentId, setCommentForEdit] = (0, $42omo.useState)('');
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const [shouldRender, setShouldRender] = (0, $42omo.useState)(false);
    const [isReplyChainCollapsed, setIsReplyChainCollapsed] = (0, $42omo.useState)(true);
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const nudgeRef = (0, $42omo.useRef)(null);
    const [popupsScrollableElement, setPopupsScrollableElement] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const [hasParentMaxHeight, setHasParentMaxHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElementRef.current,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: isEditor || false,
        annotationElement: document.getElementById(selectedAnnotation.id),
        isViewCommentMode: true,
        windowWidth: windowWidth,
        isSticky: isSticky
    });
    const apolloCacheCallback = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $g0DaR.updateApolloCacheCallbackForGA) : (0, $g0DaR.updateApolloCacheCallback);
    const handleCloseCreateComment = (0, $42omo.useCallback)(()=>{
        handleClose();
        setHoverProps(null);
        setSelectionProps(null);
        setEditorCreateProps(null);
    }, [
        handleClose,
        setHoverProps,
        setSelectionProps,
        setEditorCreateProps
    ]);
    const onlyHasReactionsSummaryErrors = (0, $42omo.useCallback)((error)=>{
        let hasOtherGqlErrors = false;
        if (error.graphQLErrors?.length > 0) error.graphQLErrors.forEach((e)=>{
            if (e.path?.includes('reactionsSummary')) (0, $4EKKB.selectInlineComment).debug('found reactionsSummary graphql error', {
                errorMessage: e.message
            });
            else hasOtherGqlErrors = true;
        });
        return !hasOtherGqlErrors && !error.networkError;
    }, []);
    const handleGqlError = (0, $42omo.useCallback)((error)=>{
        (0, $4EKKB.selectInlineComment).debug('received a gql error', {
            errorMessage: error.message
        });
        if (onlyHasReactionsSummaryErrors(error)) {
            (0, $4EKKB.selectInlineComment).debug('did not receive non-reactionsSummary errors, ignoring');
            return;
        }
        // If the error is reactions based, just set it to null and move on
        if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        else if (!(0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error
        });
        const parsedError = (0, $isdzP.parseError)(error);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message);
        if (translatedError === (0, $9CnRS.i18n).unexpectedError) {
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
            });
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(error);
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        } else {
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $isdzP.isNetworkError)(translatedError) ? $f4f7ab8b4171ff8f$var$i18n.commentLoadNetworkError : translatedError)
            });
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: parsedError.message
            });
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: parsedError.message,
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
        (0, $4EKKB.selectInlineComment).debug('Closing create comment following a gql error');
        // Close the create comment component if there was an error loading the newly created comment
        handleCloseCreateComment();
    }, [
        experienceTracker,
        flags,
        handleCloseCreateComment,
        onlyHasReactionsSummaryErrors
    ]);
    const [{ readCommentsListState: readCommentsListState, unreadCommentIDSet: unreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    // Determine if we should use cache-only policy or skip query entirely
    const shouldSkipQuery = Boolean(storedCommentData);
    // When experiment is enabled, use useCommentById with markerRef to find comment directly
    const commentByMarkerRef = (0, $lb2Lp.useCommentById)({
        markerRef: selectedAnnotation.id,
        contentId: pageId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || shouldSkipQuery,
            fetchPolicy: 'cache-first'
        }
    });
    // Use useAllCommentsData to get deleteCommentInCache function
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true
        }
    });
    const { data: data, error: gqlError } = (0, $diswb.useQuery)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $1C8XP.ActiveInlineCommentsQuery) : (0, $3B9cR.InlineCommentQuery), {
        variables: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
            pageId: pageId,
            inlineMarkerRefList: [
                selectedAnnotation.id
            ],
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        } : {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        },
        onError: undefined,
        fetchPolicy: 'cache-and-network',
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        // This allows rendering using data from a partially-successful graphql query.
        // If query receives an error, `gqlError` will be set, while any successfully
        // fetched data will be available in `data` and be rendered.
        errorPolicy: 'all'
    });
    // Use initial comment data, new hook data, or query data
    const effectiveData = (0, $42omo.useMemo)(()=>{
        if (commentByMarkerRef?.comment && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return {
            comments: {
                nodes: [
                    commentByMarkerRef.comment
                ]
            }
        };
        if (shouldSkipQuery) return {
            comments: {
                nodes: [
                    storedCommentData
                ]
            }
        };
        return data;
    }, [
        shouldSkipQuery,
        storedCommentData,
        commentByMarkerRef?.comment,
        data
    ]);
    const [reopenInlineCommentFn] = (0, $diswb.useMutation)($f4f7ab8b4171ff8f$var$InlineCommentResolveInlineCommentMutation);
    // Get the update function for the comments data manager
    const { updateCommentInCache: updateCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { pageInfo: pageInfo, error: pageInfoError } = (0, $cAdj8.usePageInfo)();
    (0, $42omo.useEffect)(()=>{
        if (pageInfoError && (0, $9wGTI.fg)('confluence_frontend_inline_comment_page_info_err')) handleGqlError(pageInfoError);
    }, [
        pageInfoError,
        handleGqlError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (gqlError) handleGqlError(gqlError);
    }, [
        gqlError,
        handleGqlError
    ]);
    // When the selectedAnnotation changes make sure we unset whatever resolved logic exists
    (0, $42omo.useEffect)(()=>{
        setResolvedComment(null);
        clearTimeout(resolveWindowCloseTimeout.current);
        resolveWindowCloseTimeout.current = undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedAnnotation
    ]);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [resolveInlineCommentFn] = (0, $diswb.useMutation)($f4f7ab8b4171ff8f$var$InlineCommentResolveInlineCommentMutation);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [deleteInlineCommentFn] = (0, $diswb.useMutation)($f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutation);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [deleteInlineCommentWithStepFn] = (0, $diswb.useMutation)($f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutationWithStepMutation);
    const [createReplyFn] = (0, $diswb.useMutation)($f4f7ab8b4171ff8f$var$InlineCommentCreateInlineReplyMutation);
    const { createInlineReplyInterop: createInlineReplyInterop } = (0, $cQCqE.useCreateInlineReplyMutation)({
        contentId: pageId
    });
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    // Comment metadata
    let commentData;
    if (commentByMarkerRef?.comment && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) commentData = commentByMarkerRef.comment; // Use comment from useCommentById
    else if (shouldSkipQuery) commentData = storedCommentData; // Use initial comment data directly
    else if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) commentData = effectiveData?.comments?.nodes?.[0];
    else commentData = effectiveData?.comments?.nodes?.[0];
    // Track experiment completion when comment data is loaded and rendered
    (0, $42omo.useEffect)(()=>{
        // Only track when we have comment data and the component is visible
        // And only when the experiment is running
        if (commentData && isInlineCommentVisible) {
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                attributes: {
                    annotationId: selectedAnnotation.id,
                    pageId: pageId,
                    pageMode: isEditor ? (0, $cD1qu.PageMode).EDIT : (0, $cD1qu.PageMode).VIEW,
                    isEditor: Boolean(isEditor)
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).stop();
        }
    }, [
        commentData,
        isInlineCommentVisible,
        storedCommentData,
        selectedAnnotation.id,
        pageId,
        isEditor,
        experienceTracker
    ]);
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: commentData?.location?.inlineResolveProperties || commentData?.location?.commentResolveProperties
    });
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = commentData?.id;
    const createdAt = commentData?.createdAt?.value;
    const createdAtNonLocalized = commentData?.createdAtNonLocalized;
    const when = commentData?.version?.when;
    const versionByDisplayName = commentData?.version?.by?.displayName;
    const isEdited = (commentData?.version?.number || 0) > 1;
    const permissions = commentData?.permissions;
    const content = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const numReplies = commentData?.replies?.length || 0;
    const commentThreadLength = 1 + numReplies; // includes root comment
    const resolveProperties = commentData?.location?.inlineResolveProperties || undefined;
    const resolvedTime = commentData?.location?.inlineResolveProperties?.resolvedTime;
    const resolvedUser = commentData?.location?.inlineResolveProperties?.resolvedUser;
    const commentUrl = isEditor && !isLivePage ? commentData?.links.editui : commentData?.links.webui;
    const reactionsSummary = commentData?.reactionsSummary ?? null;
    const shouldCollapseReplies = isReplyChainCollapsed && numReplies && numReplies > (0, $bEwJH.MAX_UNCOLLAPSED_REPIES);
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addReplyToCommentThread: addReplyToCommentThread, handleRemovingComments: handleRemovingComments, deleteParentComment: deleteParentComment, resolveParentComment: resolveParentComment, reopenParentComment: reopenParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, updateUnreadStatus: updateUnreadStatus }] = (0, $8i27m.useCommentsData)();
    const handleUpdateUnreadStatus = (0, $42omo.useCallback)((commentIds)=>{
        // Update the Comments Panel's data cache that this comment has been read
        updateUnreadStatus({
            inline: {
                [selectedAnnotation.id]: commentIds
            },
            general: {}
        }, (0, $8i27m.UnreadAction).READ);
    }, [
        updateUnreadStatus,
        selectedAnnotation.id
    ]);
    const { unreadCommentRefs: unreadCommentRefs, currentUnreadIds: currentUnreadIds, markCommentReadError: markCommentReadError } = (0, $fa00cbfae0fc22e0$export$a0ea1ecb643035a5)({
        commentData: commentData,
        isEditor: Boolean(isEditor),
        focusedCommentId: focusedCommentId ?? null,
        shouldCollapseReplies: Boolean(shouldCollapseReplies),
        setIsReplyChainCollapsed: setIsReplyChainCollapsed,
        isInlineCommentVisible: isInlineCommentVisible,
        onUpdateUnreadStatus: handleUpdateUnreadStatus
    });
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) {
            RENDER_METRIC.start();
            experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                id: selectedAnnotation.id,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    mode: pageMode,
                    framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER
                }
            });
        }
    }, [
        RENDER_METRIC,
        selectedAnnotation,
        experienceTracker,
        isEditor,
        pageMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (commentId) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'inlineCommentsSidebar',
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        mode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        commentsDeckSize: numReplies + 1,
                        commentId: // +1 for the parent comment
                        commentId
                    }
                }
            }).fire();
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) (0, $4EKKB.selectInlineComment).debug(`Comment ID or page ID was updated. Comment ID: ${commentId}, page ID: ${pageId}`);
            else experienceTracker.succeed({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
            });
        }
    // We really only need to depend on these two things and want this to fire when ONLY they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId,
        commentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (editCommentQueryId) {
            const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(editCommentQueryId);
            if (isReplyToCommentInChain) setIsReplyChainCollapsed(false);
            setCommentForEdit(editCommentQueryId);
        }
    }, [
        editCommentQueryId,
        commentData
    ]);
    (0, $42omo.useEffect)(()=>{
        const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(replyToCommentId);
        setShouldFocusNewReply(Boolean(replyToCommentId) && (isReplyToCommentInChain || replyToCommentId === commentId));
    }, [
        replyToCommentId,
        commentId,
        commentData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldFocusNewReply) {
            // for parent comment
            if (commentData && replyToCommentId === commentData.id) handleReplyToComment(commentData?.id, commentData);
            else {
                const replyObj = commentData?.replies?.find((reply)=>reply?.id === replyToCommentId);
                if (replyObj && replyObj.parentId) handleReplyToComment(replyObj.parentId, replyObj);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldFocusNewReply,
        commentData?.replies
    ]);
    (0, $42omo.useEffect)(()=>{
        if (focusedCommentId) {
            const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(focusedCommentId);
            if (isReplyToCommentInChain) setIsReplyChainCollapsed(false);
        }
    }, [
        focusedCommentId,
        commentData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (effectiveData && pageInfo) {
            (0, $4EKKB.selectInlineComment).debug('Closing create comment as the view component is ready [!apollo_loading]');
            // Close the create comment component when the view component is ready
            handleCloseCreateComment();
            setShouldRender(true);
            (0, $4EKKB.selectInlineComment).debug('Data has loaded. Rendering inline comment sidebar... [apollo_loading]');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveData,
        pageInfo
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setShouldRender(false);
            (0, $4EKKB.selectInlineComment).debug('Data changed, hiding comment', {
                ...!!commentId && {
                    commentId: commentId
                },
                pageId: pageId,
                selectedAnnotationId: selectedAnnotation.id,
                shouldRender: shouldRender
            });
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) (0, $4EKKB.selectInlineComment).debug(`Data has changed. Selected annotation ID: ${selectedAnnotation?.id}, comment ID: ${commentId}, page ID: ${pageId}, shouldRender: ${shouldRender}. Hiding inline comment sidebar (if open)...`);
            if (shouldRender) {
                (0, $4EKKB.selectInlineCommentCompoundExperience).abort({
                    abortReason: 'Inline comment experience received a new experience while already running'
                });
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    reason: `Inline comment component has received new data and is hiding the inline comment sidebar. shouldRender: ${shouldRender}`,
                    checkForTimeout: true,
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                    }
                });
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentId,
        pageId,
        selectedAnnotation
    ]);
    (0, $42omo.useEffect)(()=>{
        // if the user has been shown the resolved comment view, but navigated away to another comment
        // we need to cancel the autodismiss functionality, as it will close this entire view and not just the
        // resolved comment notification
        if (commentId !== resolvedComment?.commentId) {
            clearTimeout(resolveWindowCloseTimeout.current);
            resolveWindowCloseTimeout.current = undefined;
        }
    }, [
        commentId,
        resolvedComment,
        resolveWindowCloseTimeout
    ]);
    const toggleCommentMode = (id = '')=>{
        setCommentForEdit(id);
    };
    (0, $42omo.useEffect)(()=>{
        const markerRef = commentData?.location?.inlineMarkerRef;
        if (markerRef) setActiveHighlight(markerRef);
    }, [
        commentData,
        setActiveHighlight
    ]);
    const handleReplyToComment = (id, commentReplyData)=>{
        const referencedData = commentReplyData || commentData;
        setShouldFocusNewReply(true);
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).STANDALONE,
            user: {
                displayName: referencedData?.author?.displayName,
                accountId: referencedData?.author?.accountId
            }
        });
    };
    const deleteCommentInCacheOnUpdate = (0, $42omo.useCallback)((removalCommentId)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]);
    const handleDeleteCommentInRenderer = (0, $42omo.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        let deleteResult;
        let mtnVariables;
        if (isReply) mtnVariables = {
            variables: {
                commentIdToDelete: replyCommentId,
                deleteFrom: (0, $8z9UY.CommentDeletionLocation).LIVE
            }
        };
        else {
            try {
                // Call deleteAnnotation(selectedAnnotation) to get step and any other required variables
                deleteResult = deleteOptions?.deleteAnnotation(selectedAnnotation);
            } catch (e) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: e
                });
                return;
            }
            if (!deleteResult) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${selectedAnnotation.id} from document`)
                });
                return;
            }
            mtnVariables = {
                variables: {
                    input: {
                        commentId: commentId,
                        step: (0, $aMfLn.constructStepForGql)(deleteResult.step)
                    }
                }
            };
        }
        // After deleting it will not be available, so we need to get the inline node types before deleting.
        const inlineNodeTypes = selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined;
        // top-level comment calls `deleteInlineCommentWithStepFn`
        // reply calls `deleteInlineComment`
        const deleteFn = isReply ? deleteInlineCommentFn : deleteInlineCommentWithStepFn;
        const deletedCommentId = isReply ? replyCommentId : commentId;
        const cacheUpdateCallback = isReply ? apolloCacheCallback('delete', {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
                'DRAFT',
                'CURRENT'
            ] : [
                'CURRENT',
                'DRAFT'
            ]
        }, parentId, replyCommentId) : undefined;
        deleteFn({
            ...mtnVariables,
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(deletedCommentId), cacheUpdateCallback)
        }).then((retVal)=>{
            const { data: deleteResultData } = retVal;
            if (!deleteResultData || !isReply && !deleteResultData.deleteInlineComment) throw new Error('No data returned from mutation');
            const deleteAnnotationAndCleanUp = (annotationId)=>{
                // Update storedCommentData if it exists
                if (storedCommentData && clearStoredCommentData) {
                    if (!isReply) // Deleting the main comment, clear all data
                    clearStoredCommentData();
                    else if (replyCommentId) {
                        // Deleting a reply, remove it from the replies array
                        const updatedCommentData = {
                            ...storedCommentData,
                            replies: (storedCommentData.replies || []).filter((reply)=>reply?.id !== replyCommentId)
                        };
                        setStoredCommentData(updatedCommentData);
                    }
                }
                if (!isReply) {
                    // We handle this being false above and can't get here if it is
                    if (deleteResult) deleteOptions?.onDeleteSuccess(deleteResult.doc, annotationId);
                    // Reset the content state on successful deletion on a non-reply
                    resetContentChanged();
                    onClose && onClose();
                    deleteParentComment({
                        threadKey: annotationId,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                } else if (replyCommentId) handleRemovingComments({
                    threadKey: annotationId,
                    commentId: replyCommentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: isReply ? replyCommentId : commentId,
                annotationId: selectedAnnotation?.id,
                pageId: pageId,
                pageMode: pageMode,
                isReply: isReply,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                inlineNodeTypes: inlineNodeTypes,
                createAnalyticsEvent: createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: deleteAnnotationAndCleanUp
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, isReply ? replyCommentId : commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: isReply ? replyCommentId : commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: 'viewPageScreen',
                            attributes: {
                                commentType: (0, $8i27m.CommentType).INLINE,
                                mode: pageMode,
                                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: err,
                commentId: isReply ? replyCommentId : commentId
            });
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        commentId,
        createAnalyticsEvent,
        deleteOptions,
        deleteCommentInCacheOnUpdate,
        experienceTracker,
        resetContentChanged,
        onClose,
        pageId,
        removeUnresolvedInlineComment,
        selectedAnnotation,
        deleteInlineCommentFn,
        deleteInlineCommentWithStepFn,
        pageMode,
        getInlineNodeTypes,
        handleRemovingComments,
        deleteParentComment,
        flags
    ]);
    const handleDeleteCommentInEditorAndLivePages = (0, $42omo.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        const targetNodeType = (0, $asNlu.getTargetNodeType)(selectedAnnotation.id, true);
        const deletedCommentId = isReply ? replyCommentId : commentId;
        const cacheUpdateCallback = isReply ? apolloCacheCallback('delete', {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
                'DRAFT',
                'CURRENT'
            ] : [
                'CURRENT',
                'DRAFT'
            ]
        }, parentId, replyCommentId) : undefined;
        // both top-level comments and replies call `deleteInlineComment`
        deleteInlineCommentFn({
            variables: {
                commentIdToDelete: isReply ? replyCommentId : commentId,
                deleteFrom: isLivePage ? (0, $8z9UY.CommentDeletionLocation).LIVE : (0, $8z9UY.CommentDeletionLocation).EDITOR
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(deletedCommentId), cacheUpdateCallback)
        }).then(({ data: deleteResultData })=>{
            if (!deleteResultData || !isReply && !deleteResultData.deleteComment) throw new Error('No data returned from mutation');
            // Update storedCommentData if it exists
            if (storedCommentData) {
                if (!isReply) // Deleting the main comment, clear all data
                clearStoredCommentData();
                else if (replyCommentId) {
                    // Deleting a reply, remove it from the replies array
                    const updatedCommentData = {
                        ...storedCommentData,
                        replies: (storedCommentData.replies || []).filter((reply)=>reply?.id !== replyCommentId)
                    };
                    setStoredCommentData(updatedCommentData);
                }
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: isReply ? replyCommentId : commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: 'editPageScreen',
                    attributes: {
                        commentType: (0, $8i27m.CommentType).INLINE,
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        pageMode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        inlineNodeTypes: selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                        isReply: isReply,
                        targetNodeType: targetNodeType
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
            });
            if (!isReply) {
                onDelete?.(selectedAnnotation?.id);
                // Remove the comment from the unresolved list
                removeUnresolvedInlineComment(selectedAnnotation?.id);
                // Reset the content state on successful deletion on a non-reply
                resetContentChanged();
                deleteParentComment({
                    threadKey: selectedAnnotation.id,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            } else if (replyCommentId) handleRemovingComments({
                threadKey: selectedAnnotation.id,
                commentId: replyCommentId,
                action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                commentType: (0, $8i27m.CommentType).INLINE
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, isReply ? replyCommentId : commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags.showWarningFlag({
                        id: commentId,
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: isReply ? replyCommentId : commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: 'editPageScreen',
                            attributes: {
                                commentType: (0, $8i27m.CommentType).INLINE,
                                mode: pageMode,
                                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: err,
                commentId: isReply ? replyCommentId : commentId
            });
        });
    }, //TODO FIXME: determine the right dep array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        commentId,
        createAnalyticsEvent,
        deleteInlineCommentFn,
        deleteCommentInCacheOnUpdate,
        experienceTracker,
        pageMode,
        pageId,
        onDelete,
        selectedAnnotation,
        getInlineNodeTypes,
        resetContentChanged,
        isLivePage,
        removeUnresolvedInlineComment,
        handleRemovingComments,
        flags
    ]);
    // When handleDeleteComment() is called for a reply, both parentId and replyCommentId are defined
    // When called for a top-level comment, both are undefined
    const handleDeleteComment = (0, $42omo.useCallback)((parentId, replyCommentId)=>{
        if (!isEditor) handleDeleteCommentInRenderer(parentId, replyCommentId);
        else handleDeleteCommentInEditorAndLivePages(parentId, replyCommentId);
    }, [
        isEditor,
        handleDeleteCommentInRenderer,
        handleDeleteCommentInEditorAndLivePages
    ]);
    const handleResolveMutationFailure = (0, $42omo.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
            error: resolveError
        });
    }, [
        experienceTracker
    ]);
    const resolveUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const getReopenUpdateFn = (0, $42omo.useCallback)((onReopenCacheError)=>{
        const reopenUpdateFcn = (_dataProxy, mutationResult)=>updateCommentInCache({
                mutationResult: mutationResult,
                commentId: commentId,
                updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
                onError: onReopenCacheError
            });
        return reopenUpdateFcn;
    }, [
        updateCommentInCache,
        commentId
    ]);
    const handleResolveComment = ()=>{
        const mtnOptions = {
            variables: {
                commentId: commentId,
                resolved: true
            }
        };
        // Add the cache update function for the Comments Data Manager, if enabled
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) mtnOptions.update = resolveUpdateFn;
        resolveInlineCommentFn(mtnOptions).then(()=>{
            const annotationId = selectedAnnotation.id;
            // this will be removed when the prop becomes optional
            onResolve(annotationId);
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: annotationId,
                pageId: pageId,
                pageMode: pageMode,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            resolveParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== annotationId));
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
            if (isEditor) handleOnClose();
            else onClose && onClose();
            if (allowComments) (0, $6153444078ddb7dc$export$c71830b449cacdd)({
                commentId: commentId ?? '',
                experienceTracker: experienceTracker,
                flags: flags,
                mode: pageMode,
                annotationId: annotationId,
                formatMessage: formatMessage,
                showCommentsPanel: showCommentsPanel,
                setCurrentView: setCurrentView,
                isCommentsPanelShown: isCommentsPanelShown,
                handleReopenComment: (0, $6153444078ddb7dc$export$ddce50f11b36de55)({
                    reopenInlineCommentFn: reopenInlineCommentFn,
                    getUpdateFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? getReopenUpdateFn : undefined,
                    commentId: commentId ?? '',
                    annotationId: annotationId,
                    reopenParentComment: reopenParentComment,
                    setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
                    orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
                    highlightReopenedComment: highlightReopenedComment,
                    isEditor: isEditor ?? false,
                    eventEmitter: eventEmitter,
                    setActiveHighlight: setActiveHighlight,
                    experienceTracker: experienceTracker
                }),
                setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey
            });
            // Show the resolved comment window if not in editor
            if (!isEditor) {
                if (commentId) setResolvedComment({
                    commentId: commentId,
                    inlineMarkerRef: annotationId
                });
                // If the comment we just resolved is the same as the one we're currently viewing, set a timeout
                // to auto-close the container as it should be showing the resolved comment notification view
                if (resolvedComment?.commentId === commentData?.id) resolveWindowCloseTimeout.current = setTimeout(()=>{
                    onClose && onClose();
                }, 7500);
            }
        }).catch((err)=>{
            handleResolveMutationFailure(err);
        });
    };
    const onCancelComment = ()=>{
        setReplyToCommentId();
        setShouldFocusNewReply(false);
    };
    const handlePublishFail = (0, $42omo.useCallback)((error)=>{
        return (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: error,
            commentId: commentId,
            shouldReturnError: true,
            shouldAbortForExpectedError: true,
            compoundExperienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE)
        });
    }, [
        experienceTracker,
        commentId
    ]);
    const handleCreateReplyUnified = async (adf, onSuccess)=>{
        const parentCommentId = commentId ?? '';
        // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER
            },
            pageId: pageId,
            includeReactions: false
        };
        const queryVariables = {
            annotationId: selectedAnnotation?.id,
            pageId: pageId,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        };
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                parentCommentId: parentCommentId
            }
        });
        // Wrap the createReplyFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const replyCreationInteropWrapper = (options)=>createInlineReplyInterop({
                originalMutationFn: createReplyFn,
                options: options,
                onCacheUpdateError: handlePublishFail
            });
        return replyCreationInteropWrapper({
            variables: variables,
            update: apolloCacheCallback('create', queryVariables, parentCommentId)
        }).then(({ data: data })=>{
            const replyInlineComment = data.replyInlineComment;
            if (!replyInlineComment?.reactionsSummary) replyInlineComment.reactionsSummary = (0, $g0DaR.defaultReactionsSummary);
            const reply = {
                ...replyInlineComment,
                isUnread: false
            };
            // Update storedCommentData if it exists by adding the new reply
            if (storedCommentData && setStoredCommentData) {
                const updatedCommentData = {
                    ...storedCommentData,
                    replies: [
                        ...storedCommentData.replies || [],
                        replyInlineComment
                    ]
                };
                setStoredCommentData(updatedCommentData);
            }
            addReplyToCommentThread(selectedAnnotation.id, reply, (0, $8i27m.CommentType).INLINE);
            // reset the replyToCommentUser if any
            replyToCommentUser && setReplyToCommentId();
            (0, $g0DaR.handleCreateReplySuccess)({
                onSuccess: onSuccess,
                editCommentQueryId: editCommentQueryId,
                setCommentForEdit: setCommentForEdit,
                data: data,
                createAnalyticsEvent: createAnalyticsEvent,
                pageId: pageId,
                pageType: pageType,
                analyticsSource: (0, $en1dX.AnalyticsSource).STANDALONE,
                commentId: commentId,
                pageMode: pageMode,
                selectedAnnotation: selectedAnnotation,
                getInlineNodeTypes: undefined,
                experienceTracker: experienceTracker,
                isEditor: !!isEditor
            });
        }).catch((error)=>{
            return handlePublishFail(error);
        });
    };
    const updateReactionsCacheFnLegacy = (0, $42omo.useCallback)((emojiId, actionType, objectId, containerId, cache)=>{
        const queryVariables = {
            pageId: containerId,
            annotationId: selectedAnnotation?.id,
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        };
        try {
            const response = cache?.readQuery({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: queryVariables
            });
            if (!response?.comments?.nodes?.[0]) return;
            const comment = response.comments.nodes[0];
            let cacheReactionsSummary;
            let reply;
            // If the comment matches the comment ID, use it's reactionsSummary
            if (comment.id === objectId) cacheReactionsSummary = comment.reactionsSummary ? {
                ...comment.reactionsSummary
            } : (0, $g0DaR.defaultReactionsSummary);
            else {
                // Otherwise, find the reply that matches
                reply = comment.replies.find((r)=>r?.id === objectId);
                if (reply) cacheReactionsSummary = reply.reactionsSummary ? {
                    ...reply.reactionsSummary
                } : (0, $g0DaR.defaultReactionsSummary);
            }
            if (!cacheReactionsSummary) return;
            const reactionsAri = cacheReactionsSummary.ari || '';
            const reactionsContainerAri = cacheReactionsSummary.containerAri || '';
            let reactionsCount = cacheReactionsSummary.reactionsCount || 0;
            const updatedReactionsSummary = {
                ...cacheReactionsSummary
            };
            const updatedReactionsNodes = [
                ...cacheReactionsSummary.reactionsSummaryForEmoji || []
            ];
            if (actionType === 'add') {
                const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
                // If reaction exists, update its attributes
                if (reaction && !reaction.reacted) {
                    reaction.count++;
                    reaction.reacted = true;
                } else {
                    // Otherwise, create a new reaction
                    const newReaction = {
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    updatedReactionsNodes.push(newReaction);
                }
                ++reactionsCount;
            } else if (actionType === 'delete') {
                const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                // If reaction exists, update its attributes
                if (reactionIdx !== -1) {
                    const reaction = updatedReactionsNodes[reactionIdx];
                    // If we have more than one reaction, remove our user from it and decrement the count
                    if (reaction && reaction.count > 1) {
                        reaction.count--;
                        reaction.reacted = false;
                    } else // Otherwise, remove the reaction entirely
                    updatedReactionsNodes.splice(reactionIdx, 1);
                    --reactionsCount;
                }
            }
            updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
            updatedReactionsSummary.reactionsCount = reactionsCount ?? 0;
            // Create a deep copy of the comment to ensure Apollo detects the change
            const updatedComment = {
                ...comment,
                replies: comment.replies.map((r)=>{
                    if (r?.id === objectId) return {
                        ...r,
                        reactionsSummary: updatedReactionsSummary
                    };
                    return r;
                })
            };
            // Update the comment's reactionsSummary if it's the target comment
            if (comment.id === objectId) // @ts-ignore reactionsCount will always be defined, so the type comparison is wrong
            updatedComment.reactionsSummary = updatedReactionsSummary;
            const newData = {
                comments: {
                    nodes: [
                        updatedComment
                    ],
                    __typename: 'PaginatedCommentList'
                }
            };
            cache?.writeQuery({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: queryVariables,
                data: newData
            });
        } catch (err) {
            $f4f7ab8b4171ff8f$var$logger.error`An error occurred when updating reactions cache for ${actionType} - ${err}`;
        }
    }, [
        selectedAnnotation,
        isArchived
    ]);
    const updateReactionsCacheFn = (0, $42omo.useCallback)((emojiId, actionType, objectId, containerId, cache)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            // Call the GA function
            (0, $g0DaR.updateReactionsCacheCallbackForGA)(emojiId, actionType, objectId, pageId, selectedAnnotation, isArchived ?? false, cache);
            // Also update storedCommentData if it exists
            if (storedCommentData && setStoredCommentData) {
                const updatedCommentData = {
                    ...storedCommentData
                };
                // Find if this is the main comment or a reply
                if (storedCommentData.id === objectId) {
                    // Update main comment reactions
                    const currentReactions = storedCommentData.reactionsSummary?.reactionsSummaryForEmoji || [];
                    const updatedReactions = [
                        ...currentReactions
                    ];
                    let reactionsCount = storedCommentData.reactionsSummary?.reactionsCount || 0;
                    if (actionType === 'add') {
                        const existingReaction = updatedReactions.find((r)=>r?.emojiId === emojiId);
                        if (existingReaction && !existingReaction.reacted) {
                            existingReaction.count++;
                            existingReaction.reacted = true;
                        } else if (!existingReaction) updatedReactions.push({
                            emojiId: emojiId,
                            count: 1,
                            reacted: true,
                            id: `${storedCommentData.reactionsSummary?.containerAri}|${storedCommentData.reactionsSummary?.ari}|${emojiId}`,
                            __typename: 'ReactionsSummaryForEmoji'
                        });
                        reactionsCount++;
                    } else if (actionType === 'delete') {
                        const reactionIdx = updatedReactions.findIndex((r)=>r?.emojiId === emojiId);
                        if (reactionIdx !== -1) {
                            const reaction = updatedReactions[reactionIdx];
                            if (reaction && reaction.count > 1) {
                                reaction.count--;
                                reaction.reacted = false;
                            } else updatedReactions.splice(reactionIdx, 1);
                            reactionsCount--;
                        }
                    }
                    updatedCommentData.reactionsSummary = {
                        ...storedCommentData.reactionsSummary,
                        reactionsSummaryForEmoji: updatedReactions,
                        reactionsCount: reactionsCount,
                        ari: storedCommentData.reactionsSummary?.ari || ''
                    };
                } else // Update reply reactions
                updatedCommentData.replies = (storedCommentData.replies || []).map((reply)=>{
                    if (reply?.id === objectId) {
                        const currentReactions = reply.reactionsSummary?.reactionsSummaryForEmoji || [];
                        const updatedReactions = [
                            ...currentReactions
                        ];
                        let reactionsCount = reply.reactionsSummary?.reactionsCount || 0;
                        if (actionType === 'add') {
                            const existingReaction = updatedReactions.find((r)=>r?.emojiId === emojiId);
                            if (existingReaction && !existingReaction.reacted) {
                                existingReaction.count++;
                                existingReaction.reacted = true;
                            } else if (!existingReaction) updatedReactions.push({
                                emojiId: emojiId,
                                count: 1,
                                reacted: true,
                                id: `${reply.reactionsSummary?.containerAri}|${reply.reactionsSummary?.ari}|${emojiId}`,
                                __typename: 'ReactionsSummaryForEmoji'
                            });
                            reactionsCount++;
                        } else if (actionType === 'delete') {
                            const reactionIdx = updatedReactions.findIndex((r)=>r?.emojiId === emojiId);
                            if (reactionIdx !== -1) {
                                const reaction = updatedReactions[reactionIdx];
                                if (reaction && reaction.count > 1) {
                                    reaction.count--;
                                    reaction.reacted = false;
                                } else updatedReactions.splice(reactionIdx, 1);
                                reactionsCount--;
                            }
                        }
                        return {
                            ...reply,
                            reactionsSummary: {
                                ...reply.reactionsSummary,
                                reactionsSummaryForEmoji: updatedReactions,
                                reactionsCount: reactionsCount,
                                ari: reply.reactionsSummary?.ari || ''
                            }
                        };
                    }
                    return reply;
                });
                setStoredCommentData(updatedCommentData);
            }
        } else updateReactionsCacheFnLegacy(emojiId, actionType, objectId, containerId, cache);
    }, [
        pageId,
        selectedAnnotation,
        isArchived,
        updateReactionsCacheFnLegacy,
        storedCommentData,
        setStoredCommentData
    ]);
    const renderReplies = (0, $42omo.useCallback)((shouldCollapseReplies)=>{
        const replies = effectiveData?.comments?.nodes?.[0]?.replies || [];
        const visibleReplies = shouldCollapseReplies ? replies.slice(-1) : replies;
        return visibleReplies.map((reply)=>{
            if (!reply) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            const { id: id, permissions: replyPermissions, body: body, reactionsSummary: replyReactionsSummary, createdAtNonLocalized: replyCreatedAtNonLocalized } = reply;
            const matchingRef = unreadCommentRefs.find((refObj)=>refObj.id === id)?.ref;
            if (id === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
                key: id,
                commentId: id,
                annotationId: selectedAnnotation.id,
                displayName: reply.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous),
                avatarUrl: reply.author?.profilePicture?.path ?? '',
                pageId: pageId,
                pageType: pageType,
                spaceId: spaceId,
                content: body?.value,
                displayCommentInViewMode: toggleCommentMode,
                mode: isEditor ? 'edit' : 'view',
                isReply: true,
                hasMediaUploadPermissions: hasMediaUploadPermissions,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE,
                date: reply.version?.when ?? '',
                versionDate: reply.version?.when ?? '',
                hasParentMaxHeight: hasParentMaxHeight
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
                key: id,
                userId: reply.author?.accountId ?? '',
                displayName: reply.author?.displayName,
                avatarUrl: reply.author?.profilePicture?.path,
                date: reply.version?.when ?? '',
                dateUrl: isEditor && !isLivePage ? reply.links.editui ?? undefined : reply.links.webui ?? undefined,
                createdAt: reply.createdAt?.value ?? '',
                createdAtNonLocalized: replyCreatedAtNonLocalized ?? '',
                versionDate: reply.version?.when ?? '',
                versionByDisplayName: reply.version?.by?.displayName,
                commentId: id,
                pageId: pageId,
                pageType: pageType,
                isReply: true,
                isEdited: (reply.version?.number || 0) > 1,
                parentCommentId: reply.parentId,
                permissions: replyPermissions,
                editComment: ()=>toggleCommentMode(id),
                deleteComment: ()=>handleDeleteComment(reply.parentId, id),
                content: reply.body?.value,
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                permissionType: reply.author?.permissionType ?? undefined,
                supportedActions: [
                    'edit',
                    'delete',
                    'resolve'
                ],
                isFocused: focusedCommentId === id,
                isUnread: (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? unreadCommentIDSet.has(id) : currentUnreadIds.has(id),
                onRendered: ()=>{
                    if ((0, $9wGTI.fg)('confluence-fe-comments-deep-link-behavior')) return;
                    const targetCommentId = focusedCommentId || replyToCommentId;
                    if (sidebarOffset > 0 && targetCommentId) (0, $aHcFH.handleScrollToElement)({
                        commentId: id,
                        targetCommentId: targetCommentId,
                        isEditor: Boolean(isEditor),
                        useInstantScroll: true
                    });
                },
                unreadCommentRef: matchingRef,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: replyReactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                canAddComments: canAddComments,
                isOffline: isOffline,
                isFabricPage: true
            });
        });
    }, [
        effectiveData,
        editCommentId,
        pageType,
        pageId,
        spaceId,
        selectedAnnotation,
        isEditor,
        focusedCommentId,
        replyToCommentId,
        handleDeleteComment,
        isLivePage,
        sidebarOffset,
        currentUnreadIds,
        unreadCommentRefs,
        hasMediaUploadPermissions,
        getInlineNodeTypes,
        updateReactionsCacheFn,
        isOffline,
        canAddComments,
        formatMessage,
        unreadCommentIDSet,
        hasParentMaxHeight
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        const isReply = editCommentId === '';
        experienceTracker.abort({
            name: isReply ? (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            reason: 'comment discarded by user'
        });
        // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', isReply ? 'reply' : 'edit');
        setIsReplyChainCollapsed(true);
        setShouldFocusNewReply(false);
        onClose && onClose();
        setActiveHighlight(null);
    }, [
        experienceTracker,
        editCommentId,
        isEditor,
        onClose,
        setActiveHighlight
    ]);
    const highlightReopenedComment = (0, $42omo.useCallback)((annotationId)=>{
        // Emit the event to re-highlight the mark
        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
            [annotationId]: {
                id: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                state: (0, $cUycv.AnnotationMarkStates).ACTIVE
            }
        });
        addUnresolvedInlineComment(annotationId, pageMode);
    }, [
        addUnresolvedInlineComment,
        eventEmitter,
        pageMode
    ]);
    const navigationOptions = (0, $42omo.useMemo)(()=>({
            // We don't want to show the comment counts for the resolved comment view, and we need to make sure
            // that we're not actually viewing a different comment to the resolved comment
            disableCommentCount: Boolean(resolvedComment?.commentId === commentData?.id) || (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            commentData: commentData,
            onNavigationClick: onNavigationClick
        }), [
        resolvedComment,
        commentData,
        onNavigationClick
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!selectedAnnotation.id) return;
        if (shouldRender === false) {
            // The UI has not started rendering yet, so we don't want to check if it's visible.
            (0, $4EKKB.selectInlineComment).debug(`InlineComment has been rendered, but is returning null due to shouldRender. Selected annotation ID: ${selectedAnnotation?.id}`);
            return;
        }
        const initialTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
        // Add a guard for rapid changes
        let isCancelled = false;
        const timeoutId = setTimeout(()=>{
            // There are multiple apis and effects involved in swapping from the create comment
            // ui to the view comment ui.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            if (isCancelled && (0, $9wGTI.fg)('confluence_frontend_view_inline_is_cancelled')) return;
            requestAnimationFrame(()=>{
                if (isCancelled && (0, $9wGTI.fg)('confluence_frontend_view_inline_is_cancelled')) return;
                const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
                if (!currentTaskId) {
                    // Note -- this should not do anything (as debug points are only added to active experiences)
                    (0, $4EKKB.selectInlineComment).debug('No current task ID');
                    return;
                }
                if (initialTaskId !== currentTaskId) {
                    // The experience has been restarted or has otherwise ended.
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.attachDebugPoint({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        message: `Experience has been restarted or has otherwise ended. initialTaskId: ${initialTaskId}, currentTaskId: ${currentTaskId}`
                    });
                    return;
                }
                if (lastSelected.current !== selectedAnnotation.id) {
                    // The selected annotation has changed, this should have led to an earlier abort
                    // (as an overlapping experience is started)
                    (0, $4EKKB.selectInlineComment).debug(`View inline comment assumed aborted due to selection change. lastSelected.current: ${lastSelected?.current}, selectedAnnotation.id: ${selectedAnnotation?.id}`);
                    return;
                }
                if (!annotationElementRef.current) {
                    // We'd expect the select annotation experience to fail
                    // if no annotation is added to the document
                    // Assume this experience has aborted (or it will timeout)
                    (0, $4EKKB.selectInlineComment).debug('Show inline comment assumed aborted by deselection or selection change. This message indicate an abort failed and something has gone wrong.');
                    (0, $4EKKB.selectInlineCommentCompoundExperience).abort({
                        abortReason: 'No annotation element found for the inline comment ui to attach to.'
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'No annotation element found for the inline comment component to attach to.',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                        }
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_null_annotation_flag')) flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
                    });
                    return;
                }
                if (!sidebarEl.current) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('Document missing inline comment ui'));
                    if (shouldRender && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.fail({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        error: new Error('Document is missing inline comment sidebar element'),
                        attributes: {
                            stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                        }
                    });
                    return;
                }
                const commentUIVerticalDistanceFromAnnotation = Math.abs(annotationElementRef.current.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top);
                // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                if (commentUIVerticalDistanceFromAnnotation > 40) {
                    const isVisible = sidebarEl.current.checkVisibility();
                    if (isVisible) // if it's fully visible, but misaligned, we don't treat this as a failure
                    (0, $4EKKB.selectInlineComment).debug('View Inline Comment UI too far from annotation', {
                        misalignedBy: commentUIVerticalDistanceFromAnnotation
                    });
                    else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('View Created Comment UI too far from annotation'), {
                            misalignedBy: commentUIVerticalDistanceFromAnnotation
                        });
                        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.fail({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            error: new Error('View inline comment sidebar was rendered too far from annotation'),
                            attributes: {
                                misalignedBy: commentUIVerticalDistanceFromAnnotation,
                                stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                            }
                        });
                        return;
                    }
                }
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.succeed({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                    }
                });
                (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.complete('Inline Comment panel comment shown');
            });
        }, 10);
        return ()=>{
            isCancelled = true;
            clearTimeout(timeoutId);
            setShouldRender(false);
            const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
            if (!currentTaskId) // There is no running experience, no need to abort.
            return;
            if (initialTaskId !== currentTaskId) // The experience has been restarted or has otherwise ended.
            return;
            // If a show inline comment experience is still running while this component is in the process of being
            // unmounted, we abort it rather than fail it.
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: 'InlineComment component unmounted'
            });
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: 'Inline comment component unmounted',
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        };
    }, [
        selectedAnnotation.id,
        shouldRender,
        createAnalyticsEvent,
        experienceTracker,
        flags
    ]);
    const [isStandalonehovered, setisStandalonehovered] = (0, $42omo.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $42omo.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(false);
    const handleMouseEnter = (0, $42omo.useCallback)((id)=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        setisStandalonehovered(true);
        if (id) setHoveredCommentId(id);
    }, []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        setisStandalonehovered(false);
        setHoveredCommentId(undefined);
    }, []);
    const handleFocus = (0, $42omo.useCallback)((event)=>{
        setCommentIsFocused(true);
        event.stopPropagation();
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    if (!shouldRender) return null;
    const renderComment = ()=>{
        const matchingRef = unreadCommentRefs.find((refObj)=>refObj.id === commentId)?.ref;
        if (commentId === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
            pageId: pageId,
            date: when ?? '',
            createdAtNonLocalized: createdAtNonLocalized ?? '',
            pageType: pageType,
            annotationId: selectedAnnotation.id,
            commentId: commentId,
            spaceId: spaceId,
            content: content ?? '',
            isReply: false,
            displayCommentInViewMode: toggleCommentMode,
            avatarUrl: topCommentUserAvatar ?? '',
            displayName: topCommentDisplayName,
            dateUrl: commentUrl ?? '',
            versionDate: when ?? '',
            isEdited: isEdited,
            resolveProperties: resolveProperties,
            mode: isEditor ? 'edit' : 'view',
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            getInlineNodeTypes: getInlineNodeTypes,
            commentType: (0, $8i27m.CommentType).INLINE,
            isStandaloneComment: true,
            hasParentMaxHeight: hasParentMaxHeight
        });
        else {
            const getDeleteFn = ()=>{
                if (!isLivePage && isEditor) return undefined;
                return handleDeleteComment(undefined);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
                userId: topCommentUserId,
                avatarUrl: topCommentUserAvatar,
                displayName: topCommentDisplayName,
                date: when ?? '',
                dateUrl: commentUrl ?? '',
                createdAt: createdAt ?? '',
                createdAtNonLocalized: createdAtNonLocalized ?? '',
                versionDate: when ?? '',
                versionByDisplayName: versionByDisplayName,
                pageId: pageId,
                pageType: pageType,
                commentId: commentId ?? '',
                isReply: false,
                isEdited: isEdited,
                permissions: permissions,
                deleteComment: getDeleteFn,
                editComment: ()=>toggleCommentMode(commentId),
                content: content ?? '',
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                onClose: onClose,
                permissionType: permissionType ?? undefined,
                resolveComment: handleResolveComment,
                supportedActions: supportedTopLevelActions,
                isUnread: (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? unreadCommentIDSet.has(commentId ?? '') : currentUnreadIds.has(commentId ?? ''),
                numReplies: numReplies,
                unreadCommentRef: matchingRef,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: reactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                isStandalonehovered: isStandalonehovered,
                isHovered: hoveredCommentId === commentId || commentIsFocused && (0, $9wGTI.fg)('confluence_comments_hover_state_on_focused_comment'),
                replyToComment: handleReplyToComment,
                hideBranchingStyle: !commentData?.replies || commentData?.replies?.length === 0,
                resolveProperties: resolveProperties,
                isStandaloneComment: true,
                canAddComments: canAddComments,
                isOffline: isOffline,
                isFabricPage: true,
                onRendered: ()=>{
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.attachDebugPoint({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        message: 'Inline comment body rendered'
                    });
                }
            }), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c7FK0.ReopenedMessage), {
                resolvedUser: resolvedUser ?? undefined,
                resolvedTime: resolvedTime
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
                key: `stop-${commentId}`,
                metric: RENDER_METRIC
            }));
        }
    };
    annotationElementRef.current = document.getElementById(selectedAnnotation.id);
    // Handle case where comment has been deleted
    if (!annotationElementRef.current) {
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) (0, $4EKKB.selectInlineComment).debug('There is no annotation element element, so not rendering InlineComment');
        return null;
    }
    const isCommentAuthor = topCommentUserId === currentUserId;
    const isFirstComment = commentThreadLength === 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        nudgeRef: nudgeRef,
        pageId: pageId,
        annotationElement: annotationElementRef.current,
        navigationOptions: navigationOptions,
        onClose: isEditor ? handleOnClose : ()=>{
            onClose && onClose();
            setActiveHighlight(null);
        },
        isEditor: isEditor,
        isViewCommentMode: true,
        sidebarOffset: sidebarOffset,
        commentId: commentId,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        annotationId: selectedAnnotation?.id,
        inlineCommentRef: inlineCommentRef,
        ...(0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix') ? {
            setPopupsScrollableElement: setPopupsScrollableElement
        } : {},
        isSticky: isSticky,
        isFabricPage: true,
        authorName: topCommentDisplayName,
        onMaxHeightApplied: setHasParentMaxHeight
    }, markCommentReadError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: markCommentReadError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "inline-comment-container",
        onMouseEnter: ()=>handleMouseEnter(commentId),
        onMouseLeave: handleMouseLeave,
        onBlur: handleBlur,
        onFocus: handleFocus,
        tabIndex: 0,
        "aria-label": formatMessage($f4f7ab8b4171ff8f$var$i18n.commentAriaLabel, {
            displayName: topCommentDisplayName,
            timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                intl: intl,
                dateString: commentData?.createdAtNonLocalized,
                commentStatus: commentStatus,
                resolveProperties: commentData?.location?.inlineResolveProperties || commentData?.location?.commentResolveProperties
            })
        })
    }, renderComment()), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && commentData?.replies?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "inline-comment-reply-container"
    }, shouldCollapseReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8wupW.CollapsedReplies), {
        numCollapsedReplies: numReplies - 1,
        onClick: ()=>setIsReplyChainCollapsed(false)
    }), renderReplies(Boolean(shouldCollapseReplies))), commentData?.replies?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Svbr.CommentReplies), {
        parentComment: (0, $3ZsvI.normalizeCommentData)({
            comment: commentData,
            readCommentsListState: readCommentsListState,
            currentUserId: currentUserId ?? '',
            pageMode: pageMode,
            isOpen: true,
            type: (0, $8i27m.CommentType).INLINE
        }),
        pageInfo: pageInfo,
        pageMode: pageMode,
        parentCommentId: commentData.id,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        canAddComments: canAddComments,
        isCurrentSelectedComment: false,
        hoveredCommentId: hoveredCommentId ?? '',
        isStandaloneComment: true,
        editCommentQueryId: editCommentQueryId,
        selectedAnnotation: selectedAnnotation,
        key: `standalone-comment-replies-${commentData.id}`,
        deleteStandaloneComment: handleDeleteComment,
        replyToComment: handleReplyToComment,
        updateReactionsCacheFn: updateReactionsCacheFn,
        ...popupsScrollableElement && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix') ? {
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: document.getElementById('editor-comments-sidebar') || document.body
        } : {},
        onRendered: ()=>{
            if ((0, $9wGTI.fg)('confluence-fe-comments-deep-link-behavior')) return;
            const targetCommentId = focusedCommentId || replyToCommentId;
            if (sidebarOffset > 0 && targetCommentId && commentData?.id) (0, $aHcFH.handleScrollToElement)({
                commentId: commentData.id,
                targetCommentId: targetCommentId,
                isEditor: Boolean(isEditor),
                useInstantScroll: true
            });
        },
        hasParentMaxHeight: hasParentMaxHeight
    }), !isArchived && canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
        mode: isEditor ? 'edit' : 'view',
        "data-cy": "editor-reply-container",
        "data-testid": "inline-comment-new-reply-container",
        ref: commentContainerElementRef,
        isFabricPage: true
    }, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        size: "small",
        permissionType: permissionType ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        onCancelComment: onCancelComment,
        content: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser) : undefined,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleCreateReplyUnified,
        onContentChange: onChange,
        onEditorReady: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE)
            });
        },
        commentMode: "reply",
        commentType: isEditor ? 'edit-inline' : 'inline',
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: shouldFocusNewReply,
        pageMode: isEditor ? 'edit' : 'view',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        topLevelCommentId: commentId,
        shouldWarnOnInternalNavigation: true,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        hasParentMaxHeight: hasParentMaxHeight,
        // Needed to remount this component when we change which comment we're viewing
        key: `comment-editor-${commentId}`,
        ...popupsScrollableElement && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix') ? {
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: document.getElementById('editor-comments-sidebar') || document.body
        } : {},
        isOffline: isOffline,
        customAriaLabel: (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? formatMessage($f4f7ab8b4171ff8f$var$i18n.commentReplyAriaLabel, {
            name: topCommentDisplayName
        }) : undefined
    }))), isCommentAuthor && isFirstComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g1WP0.AsyncWrapper), {
        trigger: "inline-comments",
        showImage: false,
        width: 280,
        reference: nudgeRef
    }));
};
const $f4f7ab8b4171ff8f$export$183403b138e102b9 = (0, $7aRa9.withFlags)($f4f7ab8b4171ff8f$var$InlineCommentComponent);
module.exports["InlineComment"] = $f4f7ab8b4171ff8f$export$183403b138e102b9;

});

parcelRegister("8wupW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26870287bd8e8ddf$var$CollapsedRepliesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_x3doia51 _y3gn1h6o _4t3i1pa9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x3doia51 _y3gn1h6o _4t3i1pa9",
            __cmplp.className
        ])
    });
});
const $26870287bd8e8ddf$var$DecorLine = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n7zlia51 _4t3irdoj",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _4t3irdoj",
            __cmplp.className
        ])
    });
});
const $26870287bd8e8ddf$var$CollapsedRepliesTextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1lry1n0e _t41qmgjw _1r33tlke _1plvvuon _1c5th2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1lry1n0e _t41qmgjw _1r33tlke _1plvvuon _1c5th2mm",
            __cmplp.className
        ])
    });
});
const $26870287bd8e8ddf$export$1b7cea81591143c6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { numCollapsedReplies: numCollapsedReplies, onClick: onClick } = t0;
    let t1;
    if ($[0] !== numCollapsedReplies) {
        t1 = {
            ...(0, $9CnRS.i18n).collapsedRepliesMore,
            values: {
                numCollapsedReplies: numCollapsedReplies
            }
        };
        $[0] = numCollapsedReplies;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$DecorLine, null);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$DecorLine, null);
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] !== message) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message);
        $[4] = message;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== onClick || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$CollapsedRepliesContainer, null, t2, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$CollapsedRepliesTextContainer, {
            "data-testid": "collapsed-inline-replies",
            onClick: onClick
        }, t4));
        $[6] = onClick;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ numCollapsedReplies: numCollapsedReplies, onClick: onClick })=>{
    const message = {
        ...(0, $9CnRS.i18n).collapsedRepliesMore,
        values: {
            numCollapsedReplies: numCollapsedReplies
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$CollapsedRepliesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$DecorLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$DecorLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$CollapsedRepliesTextContainer, {
        "data-testid": "collapsed-inline-replies",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message)));
};
module.exports["CollapsedReplies"] = $26870287bd8e8ddf$export$1b7cea81591143c6;

});

parcelRegister("c7FK0", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $1YXTQ = parcelRequire("1YXTQ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9fae39c0fd447dd4$var$ReopenedMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt412zh _11c81o8v _x3doia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt412zh _11c81o8v _x3doia51",
            __cmplp.className
        ])
    });
});
const $9fae39c0fd447dd4$export$48d96e04ba74448 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { resolvedUser: resolvedUser, resolvedTime: resolvedTime } = t0;
    let t1;
    if ($[0] !== resolvedTime || $[1] !== resolvedUser) {
        t1 = resolvedUser && resolvedTime ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9fae39c0fd447dd4$var$ReopenedMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "inline-comments-common.reopened.message",
            defaultMessage: "Reopened by {person}",
            values: {
                person: resolvedUser
            }
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: resolvedTime
        })) : null;
        $[0] = resolvedTime;
        $[1] = resolvedUser;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ resolvedUser: resolvedUser, resolvedTime: resolvedTime })=>resolvedUser && resolvedTime ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9fae39c0fd447dd4$var$ReopenedMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "inline-comments-common.reopened.message",
        defaultMessage: "Reopened by {person}",
        values: {
            person: resolvedUser
        }
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: resolvedTime
    })) : null;
module.exports["ReopenedMessage"] = $9fae39c0fd447dd4$export$48d96e04ba74448;

});

parcelRegister("cQCqE", function(module, exports) {

var $310ZR = parcelRequire("310ZR");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment reply. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new reply is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
const $f9d242b7b867bd0c$var$CreateInlineReplyMutation = (0, $310ZR.default);
const $f9d242b7b867bd0c$export$9cc5e5ba32b058b7 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineReplyFn] = (0, $308Wd.useMutationInterop)($f9d242b7b867bd0c$var$CreateInlineReplyMutation);
    const addEmptyInlineRepliesArray = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: []
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comment replies. It will either call the new Comments Data Manager path or the old
    // Apollo mutation path depending on whether the relevant experiment is enabled.
    const createInlineReplyInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        const updateNewCommentReplyInCache = (_dataProxy, mutationResult)=>{
            addCommentInCache({
                newComment: addEmptyInlineRepliesArray(mutationResult.data.replyInlineComment),
                onError: onCacheUpdateError
            });
        };
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // strip old update function and other options and adjust variables as needed
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables;
            return createInlineReplyFn({
                variables: {
                    ...newVariables
                },
                update: updateNewCommentReplyInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesArray,
        createInlineReplyFn
    ]);
    return {
        createInlineReplyInterop: createInlineReplyInterop
    };
};
module.exports["useCreateInlineReplyMutation"] = $f9d242b7b867bd0c$export$9cc5e5ba32b058b7;

});

parcelRegister("8z9UY", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $651b67533e11f043$export$26bc7a3bb70e176c = /*#__PURE__*/ function(CommentDeletionLocation) {
    CommentDeletionLocation["EDITOR"] = "EDITOR";
    CommentDeletionLocation["LIVE"] = "LIVE";
    return CommentDeletionLocation;
}({});
module.exports["CommentDeletionLocation"] = $651b67533e11f043$export$26bc7a3bb70e176c;

});

parcelRegister("310ZR", function(module, exports) {
/**
 * @generated SignedSource<<3985bd40d622f881a2e9b82874b4f03c>>
 * @relayHash ff5215a72489876105d30ad9309f5653
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22405cc40e4df294f2bb5ab4cc21322f39813988c99b602fd078e2d2171b1569
const $fb6961718abb1299$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v8 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v11 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "replyInlineComment",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v6 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "childType",
                            "value": "comment"
                        },
                        {
                            "kind": "Literal",
                            "name": "contentType",
                            "value": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateInlineReplyMutation",
            "selections": v11 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateInlineReplyMutation",
            "selections": v11 /*: any*/ 
        },
        "params": {
            "cacheID": "ff5215a72489876105d30ad9309f5653",
            "id": "22405cc40e4df294f2bb5ab4cc21322f39813988c99b602fd078e2d2171b1569",
            "metadata": {},
            "name": "useCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!){replyInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$fb6961718abb1299$var$node.hash = "89307048f2bef038ef297088e05842c3";
var $fb6961718abb1299$export$2e2bcd8739ae039 = $fb6961718abb1299$var$node;
module.exports["default"] = $fb6961718abb1299$export$2e2bcd8739ae039;

});


//# sourceMappingURL=FullPageEditorComponent.23216167.js.map
